import React, { useEffect, useState, useRef } from "react";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftBadge from "components/SoftBadge";
import SoftTypography from "components/SoftTypography";
import SoftSnackbar from "components/SoftSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import upload from "../../assets/images/Upload_icon.png";
import refreshBtn from "../../assets/images/refresh_btn.png";
// import Grid from "@mui/system/Unstable_Grid/Grid";
// import { Card } from "react-bootstrap";
import Select from "react-select";
import {
  TextField,
  Box,
  Card,
  // Grid as MuiGrid,
  Grid,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { Modal } from "react-bootstrap";
import { CSVLink, CSVDownload } from "react-csv";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import moment from "moment/moment";
import noDataImg from "../../../src/assets/images/browser.png";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import FadeLoader from "react-spinners/FadeLoader";
import DOMPurify from "dompurify";
import refresh from "../../assets/images/refresh.png";
import A from "../../assets/images/briefcase.png";
import B from "../../assets/images/user.png";
import C from "../../assets/images/calendar.png";
import D from "../../assets/images/Group 27463.png";
import v1 from "../../assets/images/Vector (1).png";
import v2 from "../../assets/images/Vector.png";
import styled from "@emotion/styled";
import { match } from "stylis";
import { Icon } from "@iconify/react";
import { Table, Dropdown, Menu, Pagination } from "antd";
// import "antd/dist/antd.css";
// import "./customTable.css";
// import "./style.css";
import { colGuidelines, GuideData } from "./CandidatesList";

import {
  SBox1,
  SBox2,
  SBox3,
  SBox4,
  SBox5,
  SGHeading,
  SGSubHeading,
  SGTitles,
  SGToggles,
  SGraphSubHeading,
  SGridBox,
  SHeading,
  SHeading1,
  SKPICount,
  SKPIHeading,
  SKPISubHeading1,
  SKPISubHeading2,
  SUnderlineBox,
  SVerticalBox,
} from "./Style";
import A1 from "../../assets/images/KPI/1.png";
import A2 from "../../assets/images/KPI/2.png";
import A3 from "../../assets/images/KPI/3.png";
import A4 from "../../assets/images/KPI/4.png";
import A5 from "../../assets/images/KPI/5.png";
import A6 from "../../assets/images/KPI/6.png";
import A7 from "../../assets/images/KPI/7.png";
import info from "../../assets/images/Group 1000004191.png";
import Tooltip from "@mui/material/Tooltip";
import { useFormik } from "formik";
import * as Yup from "yup";
import EditBatch from "./EditBatch";
import Index from "../Quickfilter/index";

const ST1 = styled(Typography)({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#000000",
});

const ST2 = styled(Typography)({
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#000000",
});

const ST3 = styled(Typography)({
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#3B5092",
});

const CoursesAssigned = () => {
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const override = {
    display: "block",
    margin: "100px auto ",
    borderColor: "red",
  };
  const matchsm = useMediaQuery("(max-width:768.5px)");
  const cpId = sessionStorage.getItem("register_id");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewIndex, setViewIndex] = useState("");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [uploadingModal, setUploadingModal] = useState(false);
  const [tablerow, setTablerow] = useState([]);
  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  // =============================== Filter States ===================================== //
  const [filteroff, setFilteroff] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [statefilter, setStatefilter] = useState("");
  const [districtfilter, setDistrictfilter] = useState("");
  const [datefilter, setDatefilter] = useState([]);
  const [jffilter, setJffilter] = useState("");
  const [educationfilter, setEducationfilter] = useState("");
  const [rolefilter, setRolefilter] = useState("");
  const [degreefilter, setDegreefilter] = useState("");
  const [boardingfilter, setBoardingfilter] = useState([18, 45]);
  // =============================== Filter States ===================================== //
  // =============================== Modals States ===================================== //
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [batchState, setBatchState] = useState("");
  const [batchModalE, setBatchModalE] = useState(false);
  const [batchDetail, setBatchDetail] = useState({});
  const [addBatchModal, setAddBatchModal] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [uploadCandModal, setUploadCandModal] = useState(false);
  const [uploadAttdModal, setUploadAttdModal] = useState(false);
  const [viewMediaModal, setViewMediamodal] = useState(false);
  const [uploadMediaModal, setUploadMediaModal] = useState(false);
  const [viewDetails, setViewDetails] = useState("");
  const [refFile, setRefFile] = useState("");
  const [CSVFile, setCSVFile] = useState("");
  const [refFile1, setRefFile1] = useState("");
  const [CSVFile1, setCSVFile1] = useState("");
  const [refFile2, setRefFile2] = useState([]);
  const [mdUpDate, setMdUpDate] = useState("");
  const [CSVFile2, setCSVFile2] = useState("");
  const [stageSelect, setStageSelect] = useState({});
  const [today, setToday] = useState("");
  const [courseMode, setCourseMode] = useState("");
  const [duration, setDuration] = useState("");
  const daysOfWeek = [
    { label: "Sun", value: "6" },
    { label: "Mon", value: "0" },
    { label: "Tue", value: "1" },
    { label: "Wed", value: "2" },
    { label: "Thu", value: "3" },
    { label: "Fri", value: "4" },
    { label: "Sat", value: "5" },
  ];
  const [tracking, setTracking] = useState(false);
  const [trackId, setTrackId] = useState("");
  // =============================== Modals States ===================================== //
  // =============================== KPS States ===================================== //
  const [kpiArr, setKpiArr] = useState([
    {
      heading: "Total Courses",
      subheading: "Total Placed :",
      count1: 0,
      count2: 0,
      img: A1,
    },
    {
      heading: "Total Candidates",
      subheading: "Total Job Post :",
      count1: 0,
      count2: 0,
      img: A2,
    },
    {
      heading: "Total Vendors",
      subheading: "Recently Added :",
      count1: 0,
      count2: 0,
      img: A1,
    },
    {
      heading: "Candidates Placed",
      subheading: "Total Job Post :",
      count1: 0,
      count2: 0,
      img: A3,
    },
  ]);
  const stageoptions = [
    { label: "Interested", value: -1 },
    { label: "Under Verification", value: 0 },
    { label: "Onboarded", value: 1 },
  ];
  // =============================== KPI States ===================================== //

  // =============================== Export Column States ===================================== //
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  // const [exportData, setExportData] = useState([]);
  const getFileName = () => {
    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    console.log("getCurrentDate : ", dformat);
    const file = "course_table_" + dformat + ".csv";
    setFileName(file);
    // return "mis_data_" + dformat + ".txt";
  };
  const handleFormChange12 = (event, index, state, setState) => {
    let data = [...state];
    console.log(index);
    console.log(event);
    data[index]["isExportable"] = !data[index]["isExportable"];
    // data[index][event] = event.value;
    setState(data);
  };
  const [colHeaders, setColHeaders] = useState([
    {
      label: "Course ID",
      key: "key",
      isExportable: true,
    },
    {
      label: "Course Name",
      key: "course_name",
      isExportable: true,
    },
    {
      label: "Course provider",
      key: "org_name",
      isExportable: true,
    },
    {
      label: "Start Date",
      key: "start_date",
      isExportable: true,
    },
    {
      label: "End Date",
      key: "valid_till",
      isExportable: true,
    },
    {
      label: "Course Duration",
      key: "duration",
      isExportable: true,
    },
    {
      label: "Mode of Training",
      key: "mode_of_course",
      isExportable: true,
    },
    // {
    //   label:"Mode of Training",
    //   key: "mode_of_course",
    //   isExportable: true,
    // },
    {
      label: "Total Batch",
      key: "total_batch",
      isExportable: true,
    },
    {
      label: "Total Students",
      key: "total_students",
      isExportable: true,
    },
    {
      label: "Total Passed",
      key: "total_passed",
      isExportable: true,
    },
    {
      label: "Total Placed",
      key: "total_placed",
      isExportable: true,
    },
  ]);
  const [colHeaders1, setColHeaders1] = useState([
    {
      label: "Date",
      key: "date",
      isExportable: true,
    },
    {
      label: "Day",
      key: "day",
      isExportable: true,
    },
    {
      label: "Status",
      key: "status",
      isExportable: true,
    },
  ]);
  // =============================== Export Column States ===================================== //

  // =============================== API Data States ===================================== //
  const [courseData, setCourseData] = useState([
    // {
    //   courseId: "SMR-CO-123566",
    //   course_name: "MS Excel Basics",
    //   course_provider: "Udemy",
    //   description: "This comprehensive Excel course is designed to take you from a beginner....",
    //   total_batch: 5,
    //   total_students: 50,
    //   total_placed: 10,
    //   total_passed: 25,
    //   isActive: true,
    //   batchList: [
    //     {
    //       batch_name: "Aquila",
    //       batch_size: "50",
    //       batch_id: "B123",
    //     },
    //     {
    //       batch_name: "Taquila",
    //       batch_size: "10",
    //       batch_id: "B113",
    //     },
    //   ],
    // },
    // {
    //   courseId: "SMR-CO-123566",
    //   course_name: "MS Excel Basics",
    //   course_provider: "Udemy",
    //   description: "This comprehensive Excel course is designed to take you from a beginner....",
    //   total_batch: 5,
    //   total_students: 50,
    //   total_placed: 10,
    //   isActive: false,
    //   batchList: [
    //     {
    //       batch_name: "Aquila",
    //       batch_size: "50",
    //       batch_id: "B123",
    //     },
    //   ],
    // },
    // {
    //   courseId: "SMR-CO-123566",
    //   course_name: "MS Excel Basics",
    //   course_provider: "Udemy",
    //   description: "This comprehensive Excel course is designed to take you from a beginner....",
    //   total_batch: 5,
    //   total_students: 50,
    //   total_placed: 10,
    //   isActive: true,
    //   batchList: [],
    // },
  ]);
  const [batchData, setBatchData] = useState([
    // {
    //   name: "Aquila",
    //   batchId: "B13",
    //   from_date: "06-06-2024",
    //   till_date: "20-06-2024",
    //   total_participants: 50,
    //   total_passed: 10,
    //   total_ojt: 8,
    //   total_placed: 2,
    //   status: "yet to start",
    // },
    // {
    //   name: "Taquila",
    //   batchId: "B14",
    //   from_date: "06-06-2024",
    //   till_date: "20-06-2024",
    //   total_participants: 50,
    //   total_passed: 10,
    //   total_ojt: 8,
    //   total_placed: 2,
    //   status: "completed",
    // },
    // {
    //   name: "Daquila",
    //   batchId: "B15",
    //   from_date: "06-06-2024",
    //   till_date: "20-06-2024",
    //   total_participants: 50,
    //   total_passed: 10,
    //   total_ojt: 8,
    //   total_placed: 2,
    //   status: "ongoing",
    // },
  ]);

  const [trackData, setTrackData] = useState([
    {
      date: "10/07/2024",
      day: "Wednesday",
      status: "planned",
    },
    {
      date: "11/07/2024",
      day: "Thursday",
      status: "completed",
    },
    {
      date: "12/07/2024",
      day: "Friday",
      status: "canceled",
    },
  ]);
  // =============================== API Data States ===================================== //
  const actionOption = [
    {
      key: "1",
      label: (
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            <Icon icon="mdi:lead-pencil" />
          </div>
          &nbsp; Edit Profile
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a className="dropdown-item" href="#EditUser" style={{ display: "flex" }}>
          <div>
            <Icon icon="mdi:password-reset" />
          </div>
          &nbsp; Reset Password
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a className="dropdown-item" style={{ display: "flex" }}>
          <div>
            <Icon icon="mdi:lead-pencil" />
          </div>
          &nbsp; Edit Document
        </a>
      ),
    },
    {
      key: "4",
      label: (
        <a className="dropdown-item" style={{ display: "flex" }}>
          <div>
            <Icon icon="uil:file-download" />
          </div>
          &nbsp; Downlaod All Documents
        </a>
      ),
    },
  ];
  const handleMenuClick = (e, record) => {
    // console.log("Click on menu item:", e);
    console.log("Row data:", record);
    if (e.key == 1) {
      // setAddBatchModal(true);
      setBatchDetail(record);
      setBatchModalE(true);
    } else if (e.key == 2) {
      setUploadCandModal(true);
      setBatchDetail(record);
    } else if (e.key == 3) {
      setUploadAttdModal(true);
      setBatchDetail(record);
    } else if (e.key == 5) {
      setViewMediamodal(true);
      setBatchDetail(record);
    } else if (e.key == 6) {
      setTracking(true);
      setTrackId(record.batch_id);
      setBatchDetail(record);
    } else {
      setUploadMediaModal(true);
      setBatchDetail(record);
    }
  };
  const handleMenuClick1 = (e, record) => {
    // console.log("Click on menu item:", e);
    console.log("Row data:", record);
    if (e.key == 1) {
      // setAddBatchModal(true);
      // setBatchDetail(e);
      // setBatchModalE(true);
      HandleStatusChangeBatch(record, "yet to start");
    } else if (e.key == 2) {
      // setUploadCandModal(true);
      HandleStatusChangeBatch(record, "ongoing");
    } else {
      // setUploadMediaModal(true);
      HandleStatusChangeBatch(record, "completed");
    }
  };
  const menu = (record) => (
    <Menu onClick={(e) => handleMenuClick(e, record)}>
      <Menu.Item key="1">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            <Icon icon="mdi:lead-pencil" />
          </div>
          &nbsp; Edit Batch
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <Icon icon="mdi:lead-pencil" width="48" height="48" /> */}
            <Icon icon="material-symbols-light:upload-sharp" width="20" height="20" />
          </div>
          &nbsp; Upload Candidates
        </a>
      </Menu.Item>
      <Menu.Item key="3">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect width="24" height="24" fill="url(#pattern0_5339_34442)" />
              <defs>
                <pattern
                  id="pattern0_5339_34442"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use xlinkHref="#image0_5339_34442" transform="scale(0.015625)" />
                </pattern>
                <image
                  id="image0_5339_34442"
                  width="24"
                  height="24"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg> */}
            <Icon icon="fluent:table-add-20-regular" width="20" height="20" />
          </div>
          &nbsp; Update Attendance
        </a>
      </Menu.Item>
      <Menu.Item key="4">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <rect width="30" height="30" fill="url(#pattern0_5339_34443)" />
              <defs>
                <pattern
                  id="pattern0_5339_34443"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use xlinkHref="#image0_5339_34443" transform="scale(0.015625)" />
                </pattern>
                <image
                  id="image0_5339_34443"
                  width="30"
                  height="30"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAHYAAAB2AH6XKZyAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABH1JREFUeJzt20uoVVUYB/CfZg/t4auwtIJ89HCQ3axMbNCgqOglNXFQDSIqqUCE68AgI2hSg6hB0dPMCKLIEglt0jt6EdRVtPJmLw2MjK6gmXpt8O3jOffkuXuf69kPzT9s9jp7r72+9f3X2t/6vm/twxH8vzGsoTwRT2AGhpfTnY5jF1ZhMfakVX4d+w7T485WSjeO9Iw0hg5hXNjqxvAW5cMNw1rdGNFQvh8n5d+XUrC+7A5UFo1T4y6MKasjOeNrrE6r1Kt8a53X8XQrpQ9nw5cJRwgoSM6v+Bb9BcnLjLwJ2IjLcAbOxRS8lbPMIaPTRrAPZzW03+hz3IHtHZZXOSP4CjbhVKzDVswXS+9z6MJnOcrPhDwJWJec52I6xuJJrMQE9dfjIRkitbyQJwG7kvPopuvXoQc3CMWXYA6+z7EvLVHWMniKMIYv4Xh8jpl4puiOlO0H3IovhfLbhTt+M/4oqgNlE0Asj5/iQRyFN0Ru4psihFeBAGKJXIIPha+wGTdiZ96Cq0JADbMFCePxI9bkLbBqBMBpwibAT3kLqyIBm9QdpKl5C6saAWuEc/QXzsOVeQusCgE7sQDXYAumCY/xmLwFV4GAHszC4yJwuQ1fKWD6Uy4B+8RO1EWChJOxAstwQlGdGJFeJRf8LEb6/eT3FXgRk4ruSJ4z4LjkvK3p+ss4Xyg/UsyCd5SgfDM6nRBZmrQ7Hh8Lx2Zeg7wLsLbDMttOiORJwA6RB2jGcHTj7zbb68NrImCaJSLKYzEKZwovcgHe9N9sUykE7BM+/fXqr1oX3m2zjV7cLcLmrBiDhcKpGpSAxp2hXkxuQ0g76BPJj3FtPLNLRIiPqSdXJuFqkUCZIl6vfpF1/k3YlVXqdmckHhB7nvekCazSztAPBm5pz04U25Ph2d3CiWrc7h+VpnyVCFgrvlYh0mnLxSi3285eYYhPzKJ8VQjYrL4cTsd3HWizx8D0/AA02oB5yv8+4ANswNlJeUJK/aeS8/yUeltxqTCKlcdoYQPSRra74ZnuDPV7HOB1qMr3Ab+IjRTinb8lpf4iPNp0rRuPpDy3FLe3ulmmDbg36cNM6QZv8SAKLkx5dq/wRQ6IThicoRx96tHfqpS6ixr62/wK1LAopY2VrQhYXhIBKxL5Ewy+zr/X0NeHDQyytiXXanhvkHb+Edt0GBgOLxD+e5di8wSvJue5Yl+gFbpwEy7Hffiz6f5iMZNWO3AMUsPRuFZEpZXCs9qbOc0zoJ1n92/BVSElVsNgo9ZpnF4rVImAIp2wmqtdKQKKTM/ttzVVImBrgbJ+rxWqREBvGbKqRMBHBcr6pEBZmTFJuKp5L4O7xQYsqjUDNgtXOG+8LdJnlcQc2bM/Q5kB/bikAD0OCkvlR8CyQjQ4SIyTLTLdntQfJttXpxuUn/HKjGnCL0hT6nm8kKHeFpxTqAYdwFSdyVFsVNBWex4YK0Z4KGnxfm2mxauMOSJxksVP2COW04uzNNzy/3QVxURcJb4jmiyySDuSYz2+ECmvIuOKIzik8S8a0nxW5UI7LAAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg> */}
            <Icon icon="uil:file-upload-alt" width="20" height="20" />
          </div>
          &nbsp; Upload Media
        </a>
      </Menu.Item>
      <Menu.Item key="5">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <Icon icon="uil:file-upload-alt" width="20" height="20" /> */}
            <Icon icon="hugeicons:file-view" width="20" height="20" style={{ color: "black" }} />
          </div>
          &nbsp; View Media
        </a>
      </Menu.Item>
      <Menu.Item key="6">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <Icon icon="uil:file-upload-alt" width="20" height="20" /> */}
            <Icon
              icon="fluent-mdl2:issue-tracking"
              width="20"
              height="20"
              style={{ color: "#000" }}
            />
          </div>
          &nbsp; Track Course
        </a>
      </Menu.Item>
    </Menu>
  );
  const menuStatus = (record) => (
    <Menu onClick={(e) => handleMenuClick1(e, record)}>
      <Menu.Item key="1" value="yet to start">
        Yet To Start
      </Menu.Item>
      <Menu.Item key="2" value="ongoing">
        On Going
      </Menu.Item>
      <Menu.Item key="3" value="completed">
        Completed
      </Menu.Item>
    </Menu>
  );
  const batchColumn = [
    {
      title: "Batch ID",
      // dataIndex: "name",
      width: 150,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.batchId?.localeCompare(b?.batchId),
        multiple: 1,
      },
      render: (text) => {
        return <p>{text.batchId}</p>;
      },
    },
    {
      title: "Batch Name",
      // dataIndex: "name",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.name?.localeCompare(b?.name),
        multiple: 1,
      },
      render: (text) => {
        // let orgid = "SMR-JP-123456";
        // let courseid = "SMR-CO-123456";
        return (
          <p
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() =>
              navigate(
                `/candidates-list?show=onboarded&courseid=${text.course_id}&batchid=${text.batchId}`
              )
            }
          >
            {text.name}
          </p>
        );
      },
    },
    {
      title: "From",
      dataIndex: "from_date",
      width: 200,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.from_date?.localeCompare(b?.from_date),
        multiple: 1,
      },
    },
    {
      title: "End",
      dataIndex: "till_date",
      width: 200,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.till_date?.localeCompare(b?.till_date),
        multiple: 1,
      },
    },
    {
      title: "Participants",
      dataIndex: "total_participants",
      width: 150,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a.total_participants - b?.total_participants,
        multiple: 1,
      },
      render: (text) => <span style={{ display: "flex", justifyContent: "center" }}>{text}</span>,
    },
    {
      title: "Passed",
      dataIndex: "total_passed",
      width: 150,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.total_passed - b?.total_passed,
        multiple: 1,
      },
      render: (text) => <span style={{ display: "flex", justifyContent: "center" }}>{text}</span>,
    },
    {
      title: "Total OJT",
      dataIndex: "total_ojt",
      width: 200,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.total_ojt - b?.total_ojt,
        multiple: 1,
      },
      render: (text) => <span style={{ display: "flex", justifyContent: "center" }}>{text}</span>,
    },
    {
      title: "Total Placed",
      dataIndex: "total_placed",
      width: 150,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.total_placed - b?.total_placed,
        multiple: 1,
      },
      render: (text) => <span style={{ display: "flex", justifyContent: "center" }}>{text}</span>,
    },
    {
      title: "Avg Attendance (%)",
      // dataIndex: "average_attendance_percentage",
      width: 250,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a.average_attendance_percentage - b?.average_attendance_percentage,
        multiple: 1,
      },
      render: (text) => (
        <span style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
          {text.average_attendance_percentage !== ""
            ? `${text.average_attendance_percentage.toFixed(0)}%`
            : "0%"}
        </span>
      ),
    },
    {
      title: "Syllabus Completion (%)",
      dataIndex: "batch_syllabus_percentage",
      width: 250,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a.batch_syllabus_percentage - b?.batch_syllabus_percentage,
        multiple: 1,
      },
      render: (text) => (
        <span style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
          {`${text.toFixed(0)}%`}
        </span>
      ),
    },
    {
      title: "Status",
      // dataIndex: "status",
      width: 200,
      // fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.status?.localeCompare(b?.status),
        multiple: 1,
      },
      render: (text, record) => (
        <Dropdown overlay={() => menuStatus(record)}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              backgroundColor: "#FFF0E7",
              // backgroundColor: text.status ? "#D9EAd3" : "#F4CCCC",
              padding: "5px 7px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                width: "8px",
                height: "8px",
                backgroundColor:
                  text.status === "yet to start"
                    ? "#FF5C00"
                    : text.status === "ongoing"
                    ? "#006CD0"
                    : "#0B7B2A",
                borderRadius: "50%",
              }}
            ></Box>
            <Box
              sx={{
                fontSize: "10px",
                fontWeight: 500,
                color:
                  text.status === "yet to start"
                    ? "#FF5C00"
                    : text.status === "ongoing"
                    ? "#006CD0"
                    : "#0B7B2A",
                fontStyle: "normal",
                fontFamily: "Montserrat",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {text.status === "yet to start"
                ? "Yet To Start"
                : text.status === "ongoing"
                ? "On Going"
                : "Completed"}
            </Box>
          </Box>
        </Dropdown>
      ),
    },
    {
      title: "Action",
      // dataIndex: "action",
      width: 100,
      // fixed: !matchsm ? "left" : "none",
      // sorter: {
      //   compare: (a, b) => a?.total_ojt - b?.total_ojt,
      //   multiple: 1,
      // },
      render: (text, record) => (
        <>
          <Dropdown
            // menu={{
            //   actionOption,
            //   onClick: ({ key }) => {
            //     // if (key === "1") {
            //     //   Seteditadmin(true);
            //     //   Seteditdata(admindata);
            //     // } else if (key === "2") {
            //     //   setResetPassword(true);
            //     //   Seteditdata(admindata);
            //     // } else if (key === "4") {
            //     //   // setResetPassword(true);
            //     //   // Seteditdata(admindata);
            //     //   // downloadZipFunc
            //     //   downloadZipFunc(admindata);
            //     // } else {
            //     //   setShowModal(true);
            //     //   setCPId(admindata.key);
            //     //   setCpType(admindata.cp_type);
            //     // }
            //   },
            // }}
            overlay={() => menu(record)}
          >
            <a>
              <Icon icon="ion:ellipsis-vertical" color="black" />
            </a>
          </Dropdown>
        </>
      ),
    },
  ];

  const stylesDD = {
    // control: (baseStyles, state) => ({
    //   ...baseStyles,
    //   // borderColor: state.isFocused ? "grey" : "red",
    //   fontSize: "14px",
    //   width: !matchsm ? "200px" : "100%",
    //   height: "41px",
    //   width: "200px",
    //   fontFamily: "Poppins",
    // }),
    // option: (base) => ({
    //   ...base,
    //   // border: `1px dotted red`,
    //   height: "100%",
    //   fontSize: "14px",
    //   fontFamily: "Poppins",
    // }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: "14px",
    }),
    option: (base) => ({
      ...base,
      height: "100%",
      fontSize: "14px",
    }),
  };

  const stylesDD1 = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      fontFamily: "Poppins",
      width: "250px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };

  const menuCourseStatus = (record) => (
    <Menu onClick={(e) => handleCourseMenuClick(e, record)}>
      <Menu.Item key="1" value="planned">
        Planned
      </Menu.Item>
      <Menu.Item key="2" value="completed">
        Completed
      </Menu.Item>
      <Menu.Item key="0" value="canceled">
        Canceled
      </Menu.Item>
    </Menu>
  );

  const handleCourseMenuClick = (e, record) => {
    if (e.key == 1) {
      updateBatchCourseStatus(record, "planned");
    } else if (e.key == 2) {
      updateBatchCourseStatus(record, "completed");
    } else {
      updateBatchCourseStatus(record, "canceled");
    }
  };

  const colName1 = [
    {
      title: "Date",
      // dataIndex: "dop",
      // fixed: "left",
      key: "date",
      sorter: {
        compare: (a, b) => moment(a.date, "DD-MM-YYYY") - moment(b.date, "DD-MM-YYYY"),
      },
      render: (text) => <span>{moment(text.date).format("DD-MM-YYYY")}</span>,
      width: 200,
    },
    {
      title: "Day",
      // dataIndex: "day",
      // fixed: "left",
      key: "day",
      sorter: { compare: (a, b) => a?.day?.localeCompare(b?.day) },
      render: (text) => <span>{text.day}</span>,
      width: 200,
    },
    {
      title: "Status",
      // dataIndex: "dop",
      // fixed: "left",
      // width: "100px",
      key: "status",
      sorter: { compare: (a, b) => a?.status?.localeCompare(b?.status) },
      render: (text, record) => (
        <SoftBox sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <SoftBox sx={{ width: "65%" }}>
            <Dropdown overlay={() => menuCourseStatus(record)}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFF0E7",
                  padding: "5px 7px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  width: "80%",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor:
                      text.status === "planned"
                        ? "#FF5C00"
                        : text.status === "canceled"
                        ? "red"
                        : "#0B7B2A",
                    borderRadius: "50%",
                  }}
                ></div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    color:
                      text.status === "planned"
                        ? "#FF5C00"
                        : text.status === "canceled"
                        ? "red"
                        : "#0B7B2A",
                    fontStyle: "normal",
                    fontFamily: "Montserrat",
                    paddingLeft: "10px",
                  }}
                >
                  {text.status === "planned"
                    ? "Planned"
                    : text.status === "canceled"
                    ? "Canceled"
                    : "Completed"}
                </div>
              </div>
            </Dropdown>
          </SoftBox>
        </SoftBox>
      ),
      width: 200,
    },
  ];

  // =============================== Functions ===================================== //
  const CapitalizeFunc = (name) => {
    name = name;
    const arr = name.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    console.log("Login access:", str2);
    return str2;
  };
  const resetfunc = () => {
    setFilteroff(true);
    setBoardingfilter([18, 45]);
    setRolefilter("");
    setStatefilter("");
    setDistrictfilter("");
    setJffilter("");
    setDatefilter([]);
    // fetchCandidates();
  };
  const setFunc = () => {
    setFilteroff(false);
  };
  const batchForm = useFormik({
    initialValues: {
      batch_name: "",
      start_date: "",
      end_date: "",
      batch_type: courseMode,
      batch_limit: "",
      state: "",
      district: "",
      address: "",
      spoc_name: "",
      spoc_email: "",
      spoc_phone: "",
      off_days: "",
      hrs_per_day: "",
    },
    validationSchema: Yup.object().shape({
      batch_name: Yup.string().required("Please enter batch name"),
      // batch_limit: Yup.string().required("Please enter batch limit"),
      // batch_type: Yup.string().required(" Please select batch type"),
      start_date: Yup.string().required("Please select batch start date"),
      // end_date: Yup.string().required("Please select batch end date"),
      state: Yup.string().required("Please select state"),
      district: Yup.string().required(" Please select district"),
      address: Yup.string().required(" Please enter address"),
      spoc_name: Yup.string().required("Please enter POC name"),
      spoc_name: Yup.string().required("Please enter POC email"),
      spoc_phone: Yup.string().required("Please enter POC mobile"),
    }),

    onSubmit: async (values, { resetForm }) => {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      console.log("values", values.off_days.split(",").map(Number));
      let formData = new FormData();
      formData.append("batch_name", values.batch_name);
      formData.append("batch_limit", values.batch_limit);
      formData.append("batch_startdt", values.start_date);
      // formData.append("batch_enddt", values.end_date);
      formData.append("batch_state", values.state);
      formData.append("batch_district", values.district);
      formData.append("batch_address", values.address);
      formData.append("course_mode", courseMode);
      formData.append("spoc_name", values.spoc_name);
      formData.append("spoc_email", values.spoc_email);
      formData.append("spoc_mobile", values.spoc_phone);
      formData.append("course_id", courseId);
      formData.append(
        "weekly_off",
        values.off_days !== ""
          ? JSON.stringify(values.off_days.split(",").map(Number))
          : JSON.stringify([])
      );
      formData.append("hours_per_day", values.hrs_per_day);
      console.log(formData, "ss22");
      // skilling/list-batches?course_id=SMR_CO_Ca_Lo_755861
      // skilling/update-batch-status?batch_id=1

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/create-batch`, formData)
        .then((res) => {
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            text: "Batch added successfully",
            // showDenyButton: true,
            // confirmButtonText: "Add More",
          }).then((result) => {
            batchForm.handleReset();
            setAddBatchModal(false);
            HandleViewBatches(courseId);
            // if (result.isConfirmed) {
            //   // batchForm.resetForm();
            //   batchForm.handleReset();
            //   // window.location.reload();
            //   HandleViewBatches(courseId);
            // } else if (result.isDenied) {
            //   batchForm.handleReset();
            //   // window.location.reload();
            //   HandleViewBatches(courseId);
            // }
          });
        })
        .catch((err) => {
          setTimeout(() => {
            waitingPopup.close();
          }, 0);
          Swal.fire({
            icon: "error",
            title:
              // err?.response?.data ? err.response.data["Developer Message"]:
              "Something went wrong",
            text: err?.response?.data ? err.response.data["User Message"] : "Something went wrong.",
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
  });
  const handleClickFile = (event) => {
    hiddenFileInput.current.click();
  };
  const fetchStateList = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/state`)
      .then((res) => {
        console.log("State", res.data);
        setStateList(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const fetchCity = () => {
    const params = {
      state: batchState,
    };
    const paramString = new URLSearchParams(params).toString();
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/district?${paramString}`)
      .then((res) => {
        setDistrictList(res.data);

        console.log("District", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const HandleUploadMediaLink = async () => {
    console.log(refFile2, "ref22", CSVFile2);
    let bulkData = new FormData();
    bulkData.append("course_id", batchDetail.course_id);
    bulkData.append("batch_id", batchDetail.batch_id);
    // bulkData.append("mediafile", el);
    bulkData.append("media", CSVFile2);
    bulkData.append("uploaded_date", mdUpDate);
    bulkData.append("uploaded_by", sessionStorage.getItem("register_id"));
    if (CSVFile2 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/batch-media`, bulkData)
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "Media Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "Media Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile2("");
          setRefFile2([]);
          setMdUpDate("");
          setUploadMediaModal(false);
          // fetchBatches();
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };
  const HandleBulkUpload = async () => {
    let bulkData = new FormData();
    bulkData.append("course_id", batchDetail.course_id);
    bulkData.append("batch_id", batchDetail.batchId);
    bulkData.append("file", CSVFile);
    bulkData.append("uploaded_by", cpId);
    bulkData.append("stage", stageSelect.value);
    if (CSVFile === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload file",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/upload-candidate`, bulkData)
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "File Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "File Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile("");
          setRefFile("");
          setUploadCandModal(false);
          HandleViewBatches(batchDetail.course_id);
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  const HandleUploadMedia = async (el) => {
    console.log(refFile2, "ref22", CSVFile2);
    let bulkData = new FormData();
    bulkData.append("course_id", batchDetail.course_id);
    bulkData.append("batch_id", batchDetail.batch_id);
    bulkData.append("mediafile", el);
    bulkData.append("uploaded_date", mdUpDate);
    // bulkData.append("media", CSVFile2);
    bulkData.append("uploaded_by", sessionStorage.getItem("register_id"));
    if (CSVFile2 === "" && refFile2.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/batch-media`, bulkData)
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "Media Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "Media Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile2("");
          setRefFile2([]);
          setMdUpDate("");
          setUploadMediaModal(false);
          // fetchBatches();
          HandleViewBatches(batchDetail.course_id);
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  const HandleUploadMediaLoop = async () => {
    if (CSVFile2 === "" && refFile2.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else if (mdUpDate == "") {
      Swal.fire({
        icon: "info",
        title: "Please select date",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      if (refFile2.length > 0) {
        refFile2.map((el, i) => {
          return HandleUploadMedia(el);
        });
        // if (CSVFile2 !== "") {
        //   HandleUploadMediaLink();
        // }
      } else if (CSVFile2 !== "" && refFile2.length === 0) {
        HandleUploadMediaLink();
      }
    }
  };

  const HandleAttendenceUpload = async () => {
    let bulkData = new FormData();
    bulkData.append("course_id", batchDetail.course_id);
    bulkData.append("batch_id", batchDetail.batchId);
    bulkData.append("attendance_sheet", CSVFile1);
    bulkData.append("uploaded_by", cpId);
    if (CSVFile1 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload file",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/upload-attendance`, bulkData)
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "Attendance Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "File Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile1("");
          setRefFile1("");
          setUploadAttdModal(false);
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };
  const fetchCoursesFunc = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/vendor-assign-courses`, {
        params: { vendor_id: cpId },
      })
      .then((res) => {
        console.log("courseData", res.data);
        let data = res.data.data.map((item, id) => {
          return {
            key: item.course_id,
            orgid: item.orgid,
            org_name: item.org_name !== "" ? item.org_name : " - ",
            org_logo: item.course_img !== "" ? item.course_img : "",
            courseId: item.course_id !== "" ? item.course_id : "",
            course_name: item.name !== "" ? item.name : "",
            course_provider: item.orgid !== "" ? item.orgid : "",
            description: item.description !== "" ? item.description : " - ",
            total_batch: item?.total_batches !== "" ? item.total_batches : "0",
            total_students: item?.total_participant !== "" ? item.total_participant : "0",
            total_placed: item?.total_placement !== "" ? item.total_placement : "0",
            total_passed: item?.total_passed !== "" ? item.total_passed : "0",
            total_ojt: item?.total_ojt !== "" ? item.total_ojt : "0",
            isActive: item.active ? true : false,
            date_posting: item.date_posting !== "" ? item.date_posting : " - ",
            start_date:
              item.start_date !== "" ? moment(item.start_date).format("DD-MM-YYYY") : " - ",
            valid_till:
              item.valid_till !== "" ? moment(item.valid_till).format("DD-MM-YYYY") : " - ",
            duration: item.duration !== "" ? item.duration : " - ",
            highest_qualification:
              item.highest_qualification !== "" ? item.highest_qualification : " - ",
            mode_of_course:
              item.mode_of_course !== "" ? CapitalizeFunc(item.mode_of_course) : " - ",
            state: item.state !== "" ? item.state : " - ",
            district: item.district !== "" ? item.district : " - ",
            address: item.address !== "" ? item.address : " - ",
            brochure: item.brochure !== "" ? item.brochure : " - ",
            age_lower_range: item.app_lower_range !== "" ? item.app_lower_range : " - ",
            age_upper_range: item.app_upper_range !== "" ? item.app_upper_range : " - ",
            // createdby: item.address !== "" ? item.address : " - ",
            // modifiedby: item.address !== "" ? item.address : " - ",
            taluka: item.taluka !== "" ? item.taluka : " - ",

            candidate_count: item.candidate_count !== "" ? item.candidate_count : "-",
            fees: item.fees !== "" ? item.fees : " - ",
            spoc_name: item.spoc_name !== "" ? item.spoc_name : " - ",
            spoc_email: item.spoc_email !== "" ? item.spoc_email : " - ",
            spoc_mobile: item.spoc_mobile !== "" ? item.spoc_mobile : " - ",
            language: item.language !== "" ? item.language : " - ",
            discounted_fee: item.discounted_fee !== "" ? item.discounted_fee : " - ",
            skill_level_gain: item.skill_level_gain !== "" ? item.skill_level_gain : " - ",
            certificate_avail:
              item.certificate_avail !== "" || item.certificate_avail !== 0
                ? item.certificate_avail
                : " No ",
            certificate_prototype_link:
              item.certificate_prototype_link !== "" ? item.certificate_prototype_link : " - ",
            course_key_points: item.course_key_points !== "" ? item.course_key_points : " - ",
            course_requirements: item.course_requirements !== "" ? item.course_requirements : " - ",
            instructor_name: item.instructor_name !== "" ? item.instructor_name : " - ",
            course_title: item.course_title !== "" ? item.course_title : " - ",
            course_category: item.course_category !== "" ? item.course_category : " - ",
            discount_percent: item.discount_percent !== "" ? item.discount_percent : " - ",
            course_img: item.course_img !== "" ? item.course_img : " - ",
            rating_number: item.rating_number !== "" ? item.rating_number : " - ",
            fees_applicable: item.fees_applicable !== "" ? item.fees_applicable : " - ",
            discount_applicable: item.discount_applicable !== "" ? item.discount_applicable : " - ",
            course_overview: item.course_overview !== "" ? item.course_overview : " - ",
            student_required: item.student_required !== "" ? item.student_required : " - ",
            assign_count: item.assign_count !== "" ? item.assign_count : " - ",
          };
        });

        setCourseData(data);
      })
      .catch((err) => {
        console.log("err in course data", err);
      });
  };
  const HandleStatusChangeBatch = async (value, status) => {
    const waitingPopup = Swal.fire({
      title: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await axios
      .patch(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/update-batch-status?batch_id=${value.batchId}`,
        {
          // params: { batch_id: value.batchId },
          batch_status: status,
        }
      )
      .then((res) => {
        // setDistrict(res.data);
        setTimeout(() => {
          waitingPopup.close(); // to close swal
        }, 0);
        Swal.fire({
          icon: "success",
          text: "Batch status updated successfully",
          // showDenyButton: true,
          // confirmButtonText: "Add More",
        }).then((res) => HandleViewBatches(value.course_id));
      })
      .catch(
        (err) => (
          setTimeout(() => {
            waitingPopup.close();
          }, 0),
          Swal.fire({
            icon: "error",
            title:
              // err?.response?.data ? err.response.data["Developer Message"]:
              "Something went wrong",
            text: err?.response?.data ? err.response.data["User Message"] : "Something went wrong.",
            showConfirmButton: false,
            timer: 3000,
          })
        )
      );
  };
  const HandleViewBatches = async (courseId) => {
    setLoading(true);

    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/list-batches`, {
        params: { course_id: courseId },
      })
      .then(
        (res) => (
          setLoading(false),
          console.log("Role tabel", res.data["data"]),
          setBatchData(
            res.data["data"].map((item, id) => {
              return {
                ...item,
                key: item.batch_id,
                name: item.batch_name !== "" ? item.batch_name : " - ",
                batchId: item.batch_id !== "" ? item.batch_id : " - ",
                from_date:
                  item.start_date !== "" ? moment(item.start_date).format("DD-MM-YYYY") : " - ",
                till_date:
                  item.end_date !== "" ? moment(item.end_date).format("DD-MM-YYYY") : " - ",
                total_participants: item.total_participant,
                total_passed: item.total_passed,
                total_ojt: item.total_ojt,
                total_placed: item.total_placement,
                status:
                  item.batch_status !== "" && item.batch_status
                    ? item.batch_status
                    : "yet to start",
                course_id: item.course_id,
                orgid: item.orgid,
                media: item.media,
              };
            })
          )
        )
      )
      .catch((err) => console.log("status", err));
  };

  const fetchTrackData = async () => {
    const params = {
      // course_id: expandedRowKeys[0],
      batch_id: batchDetail.batch_id,
    };
    const paramString = new URLSearchParams(params).toString();
    setLoading(true);
    axios
      // .get(`${ngrokLink}/superadmin/candidatesearch/jobrolelist?${paramString}`)
      // skilling/batch-duration-details?batch_id=41
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/batch-duration-details?${paramString}`
      )
      .then((res) => {
        // setDistrict(res.data);
        setLoading(false);
        setTrackData(
          res.data.map((el, id) => {
            return {
              ...el,
              status:
                el.status !== null && el.status !== ""
                  ? el.status === 0
                    ? "canceled"
                    : el.status === 1
                    ? "planned"
                    : el.status === 2
                    ? "completed"
                    : "planned"
                  : "planned",
            };
          })
        );
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const updateBatchCourseStatus = async (data, statusValue) => {
    // /skilling/update-batch-status?batch_id=1
    axios
      .patch(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/update-duration-status`, {
        date: data.date,
        status: statusValue === "planned" ? 1 : statusValue === "canceled" ? 0 : 2,
        batch_id: batchDetail.batch_id,
      })
      .then((res) => {
        console.log(res.data.message, "dt11");
        let msg = res.data.message !== "" ? res.data.message : "Status updated successfully";
        Swal.fire({
          icon: "success",
          title: msg,
          showConfirmButton: false,
          timer: 3000,
        });
        fetchTrackData();
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          // title: err?.response?.data ? err?.response?.data["error"] : "Something went wrong!",
          title: "Oops! Something went wrong. We're fixing it.",
          text: err?.response?.data ? err?.response?.data["error"] : "Something went wrong!",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  // =============================== Functions ===================================== //

  // =============================== UseEffects ===================================== //
  useEffect(() => {
    fetchStateList();
    fetchCoursesFunc();
  }, []);
  useEffect(() => {
    fetchCity();
  }, [batchState]);
  useEffect(() => {
    trackId !== "" && fetchTrackData();
  }, [trackId]);
  console.log("refFile2", refFile2);
  console.log("refFile", refFile1);
  // =============================== UseEffects ===================================== //
  return (
    <DashboardLayout>
      <Box sx={{ px: 0, display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
        <SGHeading>{"All Courses Posting"}</SGHeading>

        {/* <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", pb: 1 }}> */}
        <SoftBox
          sx={{
            height: "34px",
            backgroundColor: "#FFF",
            borderRadius: "2px",
            cursor: "pointer",
            // p: 1,
          }}
          // display="flex"
          // justifyContent="center"
          // alignItems="center"
          width="40px"
          // onClick={() =>
          //   step3
          //     ? (DeclinedList(), setViewIndex(""), setShowSnackbar(false))
          //     : step1 && tableshow === 0
          //     ? (RequestedList(), setViewIndex(""), setShowSnackbar(false))
          //     : step1 && tableshow === 1
          //     ? (AcceptedList(), setViewIndex(""), setShowSnackbar(false))
          //     : (UploadedListFunc(), setViewIndex(""), setShowSnackbar(false))
          // }
          onClick={() => fetchCoursesFunc()}
        >
          <SoftBox>
            <img src={refreshBtn} />
          </SoftBox>
        </SoftBox>
        {/* </Box> */}
      </Box>
      {/* <Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {loading ? (
            <>
              {Array.from(Array(4).keys()).map((v, i) => {
                return (
                  <Grid item lg={3} sm={12} md={6} xs={12} key={i}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#FFFFFF",
                        padding: "8px",
                        borderRadius: "5px",
                      }}
                    >
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "14px", width: "120px", m: 0.5, mb: 1.7 }}
                            />

                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "20px", width: "90px", m: 0.5, mb: 1.3 }}
                            />
                          </Box>

                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "42px", width: "44px" }}
                            />
                          </Box>
                        </SBox3>
                      </SBox2>
                    </Box>
                  </Grid>
                );
              })}
            </>
          ) : (
            <>
              {kpiArr.map((v, i) => {
                return (
                  <Grid item lg={3} sm={12} md={6} xs={12} key={i}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#FFFFFF",
                        padding: "8px",
                        borderRadius: "5px",
                      }}
                    >
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <SKPIHeading>
                              {v.heading} <img src={info} height={"15px"} width={"15px"} />
                            </SKPIHeading>

                            <SKPICount>{v.count1}</SKPICount>
                          </Box>

                          <Box>
                            <img src={v.img} alt="" height={"42px"} width={"44px"} />
                          </Box>
                        </SBox3>
                      </SBox2>
                    </Box>
                  </Grid>
                );
              })}
            </>
          )}
        </Grid>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          mt: 2,
        }}
      >
        <Box sx={{ m: 0, minWidth: "300px", display: "flex", gap: "20px" }}>
          <SoftInput
            isClearable
            id="search-bar"
            className="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            placeholder="Search Courses"
          />
          {/*
            <Button
              onClick={() => (name !== "" ? handleDynamicSearch() : fetchCandidates())}
              sx={{
                m: 1,
                p: 2,
                width: !matchsm ? "110px" : "100%",
                height: "34px",
                background: "#3B5092",
                textTransform: "none",
                "&:hover": {
                  background: "#3B5092",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                }}
              >
                Search
              </Typography>
            </Button>
            <Button
              onClick={() => {
                setName("");
                fetchCandidates();
              }}
              sx={{
                visibility: name ? "visible" : "hidden",
                m: 1,
                p: 2,
                width: !matchsm ? "110px" : "100%",
                height: "34px",
                background: "#3B5092",
                textTransform: "none",
                "&:hover": {
                  background: "#3B5092",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                }}
              >
                Reset
              </Typography>
            </Button>
           */}
        </Box>

        <Box sx={{ m: 0, display: "flex", justifyContent: "space-between", gap: "20px" }}>
          <Tooltip
            key="1"
            title={tablerow.length === 0 ? "Download All" : "Download"}
            placement="top"
          >
            <SoftBox
              sx={{
                height: "33px",
                backgroundColor: "#000000",
                borderRadius: "2px",
                cursor: "pointer",
                // mr: "16px",
              }}
              display="flex"
              justifyContent="center"
              alignItems="center"
              // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
              width="40px"
              onClick={() => {
                // handleClick();
                getFileName();
              }}
            >
              <CSVLink
                // data={courseData.length === 0 ? searchData : tablerow}
                data={courseData}
                filename={fileName}
                headers={colHeaders.filter((ele) => ele.isExportable === true)}
              >
                {/* <span className="login-btn3-Text">Export</span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="46"
                  height="34"
                  viewBox="0 0 46 34"
                  fill="none"
                >
                  <rect width="45.8992" height="33.0097" rx="5" fill="#111727" />
                  <path
                    d="M20.0547 20.1191L22.9438 23.0082L25.8328 20.1191"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22.9531 16.5098V23.0102"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29.3651 20.9074C29.9931 20.4658 30.464 19.8357 30.7095 19.1084C30.955 18.381 30.9624 17.5944 30.7305 16.8626C30.4986 16.1308 30.0396 15.4919 29.4201 15.0387C28.8005 14.5854 28.0526 14.3414 27.285 14.342H26.3749C26.1577 13.4954 25.7513 12.7091 25.1862 12.0424C24.6211 11.3756 23.9121 10.8457 23.1126 10.4926C22.3131 10.1395 21.4439 9.97232 20.5705 10.0037C19.697 10.0351 18.8421 10.2643 18.07 10.6739C17.2979 11.0836 16.6288 11.663 16.1131 12.3687C15.5974 13.0743 15.2485 13.8877 15.0926 14.7477C14.9368 15.6078 14.978 16.4919 15.2133 17.3337C15.4486 18.1754 15.8718 18.9528 16.451 19.6073"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </CSVLink>
            </SoftBox>
          </Tooltip>

          {/* <Tooltip key="1" title="Filter" placement="top">
            <SoftBox
              sx={{
                height: "33px",
                backgroundColor: "#FFFFFF",
                borderRadius: "2px",
                cursor: "pointer",
                // mr: "16px",
              }}
              display="flex"
              justifyContent="center"
              alignItems="center"
              // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
              width="40px"
              onClick={() => setShowFilter(true)}
            >
              <SoftBox>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="34"
                  viewBox="0 0 39 37"
                  fill="none"
                >
                  <rect width="38.8889" height="37" rx="2" fill="white" />
                  <path
                    d="M28.8889 10H10L17.5556 18.9344V25.1111L21.3333 27V18.9344L28.8889 10Z"
                    stroke="#A4A4A4"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SoftBox>
            </SoftBox>
          </Tooltip> */}

          {/* {sessionStorage.getItem("cp_type") !== "Vakrangee" && (
            <Tooltip key="2" title="Bulk upload candidates" placement="top">
              <SoftBox
                sx={{
                  height: "33px",
                  backgroundColor: "#000000",
                  borderRadius: "2px",
                  cursor: "pointer",
                  // mr: "16px",
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                width="40px"
                onClick={() => setUploadModal(true)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <g fill="none">
                    <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                    <path
                      fill="#fff"
                      d="M8 9v2H5v9h14v-9h-3V9h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3Zm4.884-6.531l3.359 3.358a1 1 0 1 1-1.415 1.415L13 5.413V15a1 1 0 1 1-2 0V5.413L9.172 7.242a1 1 0 1 1-1.415-1.415l3.36-3.358a1.25 1.25 0 0 1 1.767 0Z"
                    />
                  </g>
                </svg>
              </SoftBox>
            </Tooltip>
          )} */}
        </Box>
      </Box>
      <Box>
        {isLoading ? (
          <Skeleton
            variant="rounded"
            animation="wave"
            sx={{ height: "753px", width: "100%", m: 0.5, mb: 1.8 }}
          />
        ) : (
          <>
            {courseData
              .filter((item, i) => {
                return name?.toLocaleLowerCase() === ""
                  ? item
                  : item.course_name?.toLocaleLowerCase().includes(name.toLocaleLowerCase());
              })
              .map((ele, id) => (
                <Box
                  key={id}
                  sx={{
                    shadows: 3,
                    backgroundColor: "#FFF9EC66",
                    p: "16px 16px 0px",
                    // pt: 1,
                    borderRadius: 1,
                    my: 2,
                    // height: "150px",
                    border: "1px solid #0000000D",
                  }}
                >
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid lg={2} xs={12}>
                      <SoftBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                        // width="25%"
                      >
                        {ele.org_logo !== "" ? (
                          <img src={ele.org_logo} alt="LoGo" width="100px" height="100px" />
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M5 35V7.66667C5 6.73325 5 6.26654 5.18166 5.91002C5.34144 5.59641 5.59641 5.34144 5.91002 5.18166C6.26654 5 6.73325 5 7.66667 5H22.3333C23.2668 5 23.7335 5 24.09 5.18166C24.4036 5.34144 24.6586 5.59641 24.8183 5.91002C25 6.26654 25 6.73325 25 7.66667V11.6667H32.3333C33.2668 11.6667 33.7335 11.6667 34.09 11.8483C34.4036 12.0081 34.6586 12.2631 34.8183 12.5767C35 12.9332 35 13.3999 35 14.3333V35H25H5Z"
                              fill="#2F80ED"
                              fillOpacity="0.66"
                            />
                            <path
                              d="M11.6667 30C11.6667 28.1591 13.1591 26.6667 15 26.6667C16.8409 26.6667 18.3333 28.1591 18.3333 30V35H11.6667V30Z"
                              fill="#2F80ED"
                              fillOpacity="0.66"
                            />
                            <path
                              d="M5 35H4.25C4.25 35.4142 4.58579 35.75 5 35.75V35ZM35 35V35.75C35.4142 35.75 35.75 35.4142 35.75 35H35ZM10 10.9167C9.58579 10.9167 9.25 11.2525 9.25 11.6667C9.25 12.0809 9.58579 12.4167 10 12.4167V10.9167ZM11.6667 12.4167C12.0809 12.4167 12.4167 12.0809 12.4167 11.6667C12.4167 11.2525 12.0809 10.9167 11.6667 10.9167V12.4167ZM18.3333 10.9167C17.9191 10.9167 17.5833 11.2525 17.5833 11.6667C17.5833 12.0809 17.9191 12.4167 18.3333 12.4167V10.9167ZM20 12.4167C20.4142 12.4167 20.75 12.0809 20.75 11.6667C20.75 11.2525 20.4142 10.9167 20 10.9167V12.4167ZM10 15.9167C9.58579 15.9167 9.25 16.2525 9.25 16.6667C9.25 17.0809 9.58579 17.4167 10 17.4167V15.9167ZM11.6667 17.4167C12.0809 17.4167 12.4167 17.0809 12.4167 16.6667C12.4167 16.2525 12.0809 15.9167 11.6667 15.9167V17.4167ZM18.3333 15.9167C17.9191 15.9167 17.5833 16.2525 17.5833 16.6667C17.5833 17.0809 17.9191 17.4167 18.3333 17.4167V15.9167ZM20 17.4167C20.4142 17.4167 20.75 17.0809 20.75 16.6667C20.75 16.2525 20.4142 15.9167 20 15.9167V17.4167ZM10 20.9167C9.58579 20.9167 9.25 21.2525 9.25 21.6667C9.25 22.0809 9.58579 22.4167 10 22.4167V20.9167ZM11.6667 22.4167C12.0809 22.4167 12.4167 22.0809 12.4167 21.6667C12.4167 21.2525 12.0809 20.9167 11.6667 20.9167V22.4167ZM18.3333 20.9167C17.9191 20.9167 17.5833 21.2525 17.5833 21.6667C17.5833 22.0809 17.9191 22.4167 18.3333 22.4167V20.9167ZM20 22.4167C20.4142 22.4167 20.75 22.0809 20.75 21.6667C20.75 21.2525 20.4142 20.9167 20 20.9167V22.4167ZM18.3333 35V35.75H19.0833V35H18.3333ZM11.6667 35H10.9167V35.75H11.6667V35ZM30 17.5833C29.5858 17.5833 29.25 17.9191 29.25 18.3333C29.25 18.7475 29.5858 19.0833 30 19.0833V17.5833ZM30.0167 19.0833C30.4309 19.0833 30.7667 18.7475 30.7667 18.3333C30.7667 17.9191 30.4309 17.5833 30.0167 17.5833V19.0833ZM30 22.5833C29.5858 22.5833 29.25 22.9191 29.25 23.3333C29.25 23.7475 29.5858 24.0833 30 24.0833V22.5833ZM30.0167 24.0833C30.4309 24.0833 30.7667 23.7475 30.7667 23.3333C30.7667 22.9191 30.4309 22.5833 30.0167 22.5833V24.0833ZM30 27.5833C29.5858 27.5833 29.25 27.9191 29.25 28.3333C29.25 28.7475 29.5858 29.0833 30 29.0833V27.5833ZM30.0167 29.0833C30.4309 29.0833 30.7667 28.7475 30.7667 28.3333C30.7667 27.9191 30.4309 27.5833 30.0167 27.5833V29.0833ZM34.8183 12.5767L34.1501 12.9172L34.1501 12.9172L34.8183 12.5767ZM34.09 11.8483L33.7495 12.5166L33.7495 12.5166L34.09 11.8483ZM24.09 5.18166L23.7495 5.84991L23.7495 5.84991L24.09 5.18166ZM24.8183 5.91002L24.1501 6.25051L24.1501 6.25051L24.8183 5.91002ZM5.18166 5.91002L5.84991 6.25051L5.84991 6.25051L5.18166 5.91002ZM5.91002 5.18166L6.25051 5.84991L6.25051 5.84991L5.91002 5.18166ZM4.25 7.66667V35H5.75V7.66667H4.25ZM7.66667 5.75H22.3333V4.25H7.66667V5.75ZM24.25 7.66667V11.6667H25.75V7.66667H24.25ZM24.25 11.6667V35H25.75V11.6667H24.25ZM5 35.75H25V34.25H5V35.75ZM25 35.75H35V34.25H25V35.75ZM34.25 14.3333V35H35.75V14.3333H34.25ZM25 12.4167H32.3333V10.9167H25V12.4167ZM10 12.4167H11.6667V10.9167H10V12.4167ZM18.3333 12.4167H20V10.9167H18.3333V12.4167ZM10 17.4167H11.6667V15.9167H10V17.4167ZM18.3333 17.4167H20V15.9167H18.3333V17.4167ZM10 22.4167H11.6667V20.9167H10V22.4167ZM18.3333 22.4167H20V20.9167H18.3333V22.4167ZM17.5833 30V35H19.0833V30H17.5833ZM18.3333 34.25H11.6667V35.75H18.3333V34.25ZM12.4167 35V30H10.9167V35H12.4167ZM15 27.4167C16.4267 27.4167 17.5833 28.5733 17.5833 30H19.0833C19.0833 27.7448 17.2552 25.9167 15 25.9167V27.4167ZM15 25.9167C12.7448 25.9167 10.9167 27.7448 10.9167 30H12.4167C12.4167 28.5733 13.5733 27.4167 15 27.4167V25.9167ZM30 19.0833H30.0167V17.5833H30V19.0833ZM30 24.0833H30.0167V22.5833H30V24.0833ZM30 29.0833H30.0167V27.5833H30V29.0833ZM35.75 14.3333C35.75 13.879 35.7506 13.4931 35.7248 13.1776C35.6983 12.8533 35.6403 12.5378 35.4866 12.2362L34.1501 12.9172C34.1781 12.9721 34.2109 13.0682 34.2298 13.2997C34.2494 13.54 34.25 13.8542 34.25 14.3333H35.75ZM32.3333 12.4167C32.8124 12.4167 33.1266 12.4172 33.3669 12.4369C33.5985 12.4558 33.6946 12.4886 33.7495 12.5166L34.4305 11.1801C34.1289 11.0264 33.8134 10.9684 33.4891 10.9419C33.1735 10.9161 32.7877 10.9167 32.3333 10.9167V12.4167ZM35.4866 12.2362C35.2549 11.7815 34.8852 11.4118 34.4305 11.1801L33.7495 12.5166C33.922 12.6045 34.0622 12.7447 34.1501 12.9172L35.4866 12.2362ZM22.3333 5.75C22.8124 5.75 23.1266 5.75058 23.3669 5.77022C23.5985 5.78913 23.6946 5.82193 23.7495 5.84991L24.4305 4.5134C24.1289 4.35972 23.8134 4.30169 23.4891 4.2752C23.1735 4.24942 22.7877 4.25 22.3333 4.25V5.75ZM25.75 7.66667C25.75 7.21233 25.7506 6.82647 25.7248 6.51093C25.6983 6.18663 25.6403 5.87113 25.4866 5.56952L24.1501 6.25051C24.1781 6.30542 24.2109 6.40154 24.2298 6.63308C24.2494 6.87337 24.25 7.18758 24.25 7.66667H25.75ZM23.7495 5.84991C23.922 5.93779 24.0622 6.07803 24.1501 6.25051L25.4866 5.56952C25.2549 5.1148 24.8852 4.7451 24.4305 4.5134L23.7495 5.84991ZM5.75 7.66667C5.75 7.18758 5.75058 6.87337 5.77022 6.63308C5.78913 6.40154 5.82193 6.30542 5.84991 6.25051L4.5134 5.56952C4.35972 5.87113 4.30169 6.18663 4.2752 6.51093C4.24942 6.82647 4.25 7.21233 4.25 7.66667H5.75ZM7.66667 4.25C7.21233 4.25 6.82647 4.24942 6.51093 4.2752C6.18663 4.30169 5.87113 4.35972 5.56952 4.5134L6.25051 5.84991C6.30542 5.82193 6.40154 5.78913 6.63308 5.77022C6.87337 5.75058 7.18758 5.75 7.66667 5.75V4.25ZM5.84991 6.25051C5.93779 6.07803 6.07803 5.93779 6.25051 5.84991L5.56952 4.5134C5.1148 4.74509 4.74509 5.1148 4.5134 5.56952L5.84991 6.25051Z"
                              fill="#3C3C3C"
                            />
                          </svg>
                        )}
                      </SoftBox>
                    </Grid>
                    <Grid lg={8} xs={12}>
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        gap="10px"
                        justifyContent="space-around"
                      >
                        <SoftBox
                          display="flex"
                          justifyContent="flex-start"
                          alignItems="flex-end"
                          gap="15px"
                        >
                          {/* <ST1>Company name:</ST1> */}
                          <Box
                            sx={{
                              fontSize: "20px",
                              fontWeight: 600,
                              color: "#000000",
                              fontStyle: "normal",
                              fontFamily: "Montserrat",
                              display: "flex",
                              alignItems: "flex-end",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={() => (
                              viewDetails !== "" ? setViewDetails("") : setViewDetails(id),
                              setViewIndex("")
                            )}
                          >
                            {ele.org_name}
                            {ele.course_name}
                          </Box>
                          {/* <SoftBadge
                        variant="contained"
                        color={ele.isActive ? "success" : "info"}
                        size="sm"
                        badgeContent={
                          // text >= 80
                          //   ? "Excellent Match"
                          //   : text < 80 && text >= 45
                          //   ? "Medium Match"
                          //   : "Poor Match"
                          // text.resume ? "View" : "Upload"
                          ele.isActive ? "Active" : "Inactive"
                        }
                        container
                      /> */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 1,
                              // backgroundColor: "#FFF0E7",
                              backgroundColor: ele.isActive ? "#D9EAd3" : "#F4CCCC",
                              padding: "5px 7px",
                              borderRadius: "8px",
                            }}
                          >
                            <Box
                              sx={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: ele.isActive ? "#0B7B2A" : "#FF0000",
                                borderRadius: "50%",
                              }}
                            ></Box>
                            <Box
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: ele.isActive ? "#0B7B2A" : "#FF0000",
                                fontStyle: "normal",
                                fontFamily: "Montserrat",
                              }}
                            >
                              {ele.isActive ? "Active" : "Inactive"}
                            </Box>
                          </Box>
                        </SoftBox>
                        {/* <ST1>{ele.course_requirements}</ST1> */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Box sx={{ backgroundColor: "#FFF0E7", padding: "5px 7px" }}>
                            <Box
                              sx={{
                                fontSize: "16px",
                                fontWeight: 700,
                                color: "#6C6C6C",
                                fontStyle: "normal",
                                fontFamily: "Public Sans",
                              }}
                            >
                              {"Total Batches : "}
                              <span style={{ color: "#FF7500" }}>{ele.total_batch}</span>
                            </Box>
                          </Box>
                          <Box sx={{ backgroundColor: "#FFF0E7", padding: "5px 7px" }}>
                            <Box
                              sx={{
                                fontSize: "16px",
                                fontWeight: 700,
                                color: "#6C6C6C",
                                fontStyle: "normal",
                                fontFamily: "Public Sans",
                              }}
                            >
                              {"Total Participants : "}
                              <span style={{ color: "#FF7500" }}>{ele.total_students}</span>
                            </Box>
                          </Box>
                          <Box sx={{ backgroundColor: "#FFF0E7", padding: "5px 7px" }}>
                            <Box
                              sx={{
                                fontSize: "16px",
                                fontWeight: 700,
                                color: "#6C6C6C",
                                fontStyle: "normal",
                                fontFamily: "Public Sans",
                              }}
                            >
                              {"Total Passed : "}
                              <span style={{ color: "#FF7500" }}>{ele.total_passed}</span>
                            </Box>
                          </Box>

                          <Box sx={{ backgroundColor: "#FFF0E7", padding: "5px 7px" }}>
                            <Box
                              sx={{
                                fontSize: "16px",
                                fontWeight: 700,
                                color: "#6C6C6C",
                                fontStyle: "normal",
                                fontFamily: "Public Sans",
                              }}
                            >
                              {"Total Placed : "}
                              <span style={{ color: "#FF7500" }}>{ele.total_placed}</span>
                            </Box>
                          </Box>
                        </Box>
                        {/* {ele?.batchList.length !== 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 2,
                          // height: "50px",
                        }}
                      >
                        {ele?.batchList.map((item, id) => (
                          <Box
                            key={item.batch_id}
                            sx={{ backgroundColor: "#abe9f7", padding: "5px 7px", borderRadius: 1 }}
                          >
                            <Box
                              sx={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color: "#08a1c4",
                                fontStyle: "normal",
                                fontFamily: "Public Sans",
                              }}
                            >
                              {item.batch_name}
                              
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )} */}
                      </SoftBox>
                    </Grid>
                    <Grid lg={2} xs={12}>
                      <SoftBox
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="center"
                        gap="15px"
                        // height="100%"
                        // width="25%"
                      >
                        <Tooltip title="Download Brochure" placement="top">
                          <Link to={ele.brochure} target="_blank" download>
                            <Box sx={{ cursor: "pointer" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                width="48"
                                height="42"
                                viewBox="0 0 48 42"
                                fill="none"
                              >
                                <rect width="48" height="42" rx="5" fill="#FFF0E7" />
                                <rect
                                  x="12"
                                  y="9"
                                  width="24"
                                  height="24"
                                  fill="url(#pattern0_5312_34518)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0_5312_34518"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <use
                                      xlinkHref="#image0_5312_34518"
                                      transform="scale(0.0078125)"
                                    />
                                  </pattern>
                                  <image
                                    id="image0_5312_34518"
                                    width="128"
                                    height="128"
                                    xlinkHref="data:image/png;base64,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"
                                  />
                                </defs>
                              </svg>
                            </Box>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Add Batch" placement="top">
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => (
                              setAddBatchModal(true),
                              setCourseId(ele.courseId),
                              setDuration(ele.duration),
                              setCourseMode(ele.mode_of_course),
                              setToday(ele.start_date)
                            )}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="48"
                              height="42"
                              viewBox="0 0 48 42"
                              fill="none"
                            >
                              <rect width="48" height="42" rx="5" fill="#FFF0E7" />
                              <rect
                                x="12"
                                y="9"
                                width="24"
                                height="24"
                                fill="url(#pattern0_5312_34639)"
                              />
                              <defs>
                                <pattern
                                  id="pattern0_5312_34639"
                                  patternContentUnits="objectBoundingBox"
                                  width="1"
                                  height="1"
                                >
                                  <use
                                    xlinkHref="#image0_5312_34639"
                                    transform="scale(0.0078125)"
                                  />
                                </pattern>
                                <image
                                  id="image0_5312_34639"
                                  width="128"
                                  height="128"
                                  xlinkHref="data:image/png;base64,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"
                                />
                              </defs>
                            </svg>
                          </Box>
                        </Tooltip>
                        {/* <Tooltip title="Edit Batch" placement="top">
                      <Box>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5 14C4.71667 14 4.47917 13.9042 4.2875 13.7125C4.09583 13.5208 4 13.2833 4 13C4 12.7167 4.09583 12.4792 4.2875 12.2875C4.47917 12.0958 4.71667 12 5 12H10C10.2833 12 10.5208 12.0958 10.7125 12.2875C10.9042 12.4792 11 12.7167 11 13C11 13.2833 10.9042 13.5208 10.7125 13.7125C10.5208 13.9042 10.2833 14 10 14H5ZM5 10C4.71667 10 4.47917 9.90417 4.2875 9.7125C4.09583 9.52083 4 9.28333 4 9C4 8.71667 4.09583 8.47917 4.2875 8.2875C4.47917 8.09583 4.71667 8 5 8H14C14.2833 8 14.5208 8.09583 14.7125 8.2875C14.9042 8.47917 15 8.71667 15 9C15 9.28333 14.9042 9.52083 14.7125 9.7125C14.5208 9.90417 14.2833 10 14 10H5ZM5 6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H14C14.2833 4 14.5208 4.09583 14.7125 4.2875C14.9042 4.47917 15 4.71667 15 5C15 5.28333 14.9042 5.52083 14.7125 5.7125C14.5208 5.90417 14.2833 6 14 6H5ZM13 19V17.35C13 17.2167 13.025 17.0875 13.075 16.9625C13.125 16.8375 13.2 16.725 13.3 16.625L18.525 11.425C18.675 11.275 18.8417 11.1667 19.025 11.1C19.2083 11.0333 19.3917 11 19.575 11C19.775 11 19.9667 11.0375 20.15 11.1125C20.3333 11.1875 20.5 11.3 20.65 11.45L21.575 12.375C21.7083 12.525 21.8125 12.6917 21.8875 12.875C21.9625 13.0583 22 13.2417 22 13.425C22 13.6083 21.9667 13.7958 21.9 13.9875C21.8333 14.1792 21.725 14.35 21.575 14.5L16.375 19.7C16.275 19.8 16.1625 19.875 16.0375 19.925C15.9125 19.975 15.7833 20 15.65 20H14C13.7167 20 13.4792 19.9042 13.2875 19.7125C13.0958 19.5208 13 19.2833 13 19ZM14.5 18.5H15.45L18.475 15.45L18.025 14.975L17.55 14.525L14.5 17.55V18.5ZM18.025 14.975L17.55 14.525L18.475 15.45L18.025 14.975Z"
                            fill="#5F6368"
                          />
                        </svg>
                      </Box>
                    </Tooltip> */}
                      </SoftBox>
                    </Grid>
                    <Box width="100%">
                      {/* {tracking && (
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: "15px", mb: 2 }}>
                            <Box onClick={() => setTracking(false)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="27"
                                viewBox="0 0 27 27"
                                fill="none"
                              >
                                <rect width="27" height="27" rx="13.5" fill="#D9D9D9" />
                                <path
                                  d="M16.2008 18.9016L10.8008 13.5016L16.2008 8.10156"
                                  stroke="black"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </Box>
                            <Box
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                              }}
                            >
                              {batchDetail.batch_name}
                            </Box>
                          </Box>
                          <Tooltip
                            key="1"
                            title={tablerow.length === 0 ? "Download All" : "Download"}
                            placement="top"
                          >
                            <Box
                              sx={{
                                height: "33px",
                                backgroundColor: "#000000",
                                borderRadius: "2px",
                                cursor: "pointer",
                              }}
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                              width="40px"
                              onClick={() => (
                                setShow(!show),
                                // setFileName(() => {
                                //   getFileName();
                                // })
                                getFileName()
                              )}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="46"
                                height="34"
                                viewBox="0 0 46 34"
                                fill="none"
                              >
                                <rect width="45.8992" height="33.0097" rx="5" fill="#111727" />
                                <path
                                  d="M20.0547 20.1191L22.9438 23.0082L25.8328 20.1191"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M22.9531 16.5098V23.0102"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M29.3651 20.9074C29.9931 20.4658 30.464 19.8357 30.7095 19.1084C30.955 18.381 30.9624 17.5944 30.7305 16.8626C30.4986 16.1308 30.0396 15.4919 29.4201 15.0387C28.8005 14.5854 28.0526 14.3414 27.285 14.342H26.3749C26.1577 13.4954 25.7513 12.7091 25.1862 12.0424C24.6211 11.3756 23.9121 10.8457 23.1126 10.4926C22.3131 10.1395 21.4439 9.97232 20.5705 10.0037C19.697 10.0351 18.8421 10.2643 18.07 10.6739C17.2979 11.0836 16.6288 11.663 16.1131 12.3687C15.5974 13.0743 15.2485 13.8877 15.0926 14.7477C14.9368 15.6078 14.978 16.4919 15.2133 17.3337C15.4486 18.1754 15.8718 18.9528 16.451 19.6073"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </Box>
                          </Tooltip>
                        </Box>
                      )} */}
                      {viewIndex === id && !tracking && (
                        <Box p={2} className="batch-table">
                          <Table
                            loading={loading}
                            rowClassName={(record, index) =>
                              index % 2 === 0 ? "table-row-even" : "table-row-odd"
                            }
                            columns={batchColumn}
                            dataSource={batchData}
                            scroll={{ x: 1900, y: 400 }}
                            pagination={{
                              defaultPageSize: "5",
                              pageSizeOptions: ["5", "10", "20", "50", "100", "500"],
                              showSizeChanger: true,
                              showTotal: (total, range) => (
                                <span>
                                  Showing{" "}
                                  <strong>
                                    {range[0]} - {range[1]}
                                  </strong>{" "}
                                  results of {total}
                                </span>
                              ),
                            }}
                          />
                        </Box>
                      )}
                      {viewIndex === id && tracking && (
                        <>
                          <Box
                            sx={{ display: "flex", justifyContent: "space-between", mb: 0, px: 2 }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: "15px", mb: 0 }}>
                              <Box sx={{ cursor: "pointer" }} onClick={() => setTracking(false)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27"
                                  height="27"
                                  viewBox="0 0 27 27"
                                  fill="none"
                                >
                                  <rect width="27" height="27" rx="13.5" fill="#D9D9D9" />
                                  <path
                                    d="M16.2008 18.9016L10.8008 13.5016L16.2008 8.10156"
                                    stroke="black"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </Box>
                              <Box
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: 700,
                                  color: "#6C6C6C",
                                  fontStyle: "normal",
                                  fontFamily: "Public Sans",
                                }}
                              >
                                {batchDetail.batch_name}
                              </Box>
                            </Box>
                            <Tooltip
                              key="1"
                              title={tablerow.length === 0 ? "Download All" : "Download"}
                              placement="top"
                            >
                              <Box
                                sx={{
                                  height: "33px",
                                  backgroundColor: "#FFF0E7",
                                  borderRadius: "2px",
                                  cursor: "pointer",
                                }}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                                width="40px"
                                onClick={() => (
                                  setShow(!show),
                                  // setFileName(() => {
                                  //   getFileName();
                                  // })
                                  getFileName()
                                )}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="46"
                                  height="34"
                                  viewBox="0 0 46 34"
                                  fill="#FFF0E7"
                                >
                                  <rect width="45.8992" height="33.0097" rx="5" fill="#FFF0E7" />
                                  <path
                                    d="M20.0547 20.1191L22.9438 23.0082L25.8328 20.1191"
                                    stroke="#FF7500"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M22.9531 16.5098V23.0102"
                                    stroke="#FF7500"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M29.3651 20.9074C29.9931 20.4658 30.464 19.8357 30.7095 19.1084C30.955 18.381 30.9624 17.5944 30.7305 16.8626C30.4986 16.1308 30.0396 15.4919 29.4201 15.0387C28.8005 14.5854 28.0526 14.3414 27.285 14.342H26.3749C26.1577 13.4954 25.7513 12.7091 25.1862 12.0424C24.6211 11.3756 23.9121 10.8457 23.1126 10.4926C22.3131 10.1395 21.4439 9.97232 20.5705 10.0037C19.697 10.0351 18.8421 10.2643 18.07 10.6739C17.2979 11.0836 16.6288 11.663 16.1131 12.3687C15.5974 13.0743 15.2485 13.8877 15.0926 14.7477C14.9368 15.6078 14.978 16.4919 15.2133 17.3337C15.4486 18.1754 15.8718 18.9528 16.451 19.6073"
                                    stroke="#FF7500"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </Box>
                            </Tooltip>
                          </Box>
                          <Box p={2} className="batch-table">
                            <Table
                              loading={loading}
                              rowClassName={(record, index) =>
                                index % 2 === 0 ? "table-row-even" : "table-row-odd"
                              }
                              columns={colName1}
                              dataSource={trackData}
                              // scroll={{ x: 1900, y: 400 }}
                              pagination={{
                                defaultPageSize: "5",
                                pageSizeOptions: ["5", "10", "20", "50", "100"],
                                showSizeChanger: true,
                                showTotal: (total, range) => (
                                  <span>
                                    Showing{" "}
                                    <strong>
                                      {range[0]} - {range[1]}
                                    </strong>{" "}
                                    results of {total}
                                  </span>
                                ),
                              }}
                            />
                          </Box>
                        </>
                      )}
                    </Box>
                    {/* {viewDetails && <Box></Box>} */}
                    <Box>
                      {viewDetails === id && (
                        <Grid container spacing={0} p={2}>
                          {/* <Box sx={{ width: "100%", p: 2 }}> */}
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Candidates Requirement:</span>{" "}
                                  {ele.candidate_count ? ele.candidate_count : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>

                          <Grid item lg={6} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>
                                    Assigned Candidates Requirement:
                                  </span>{" "}
                                  {ele.candidate_count ? ele.candidate_count : "NA"}
                                </ST1>
                              </Box>

                              {/* <ST1 variant="body2">
                                            {ele.candidate_required ? ele.candidate_required : "NA"}
                                          </ST1> */}
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Education:</span>{" "}
                                  {ele.highest_qualification ? ele.highest_qualification : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                  style={{ textTransform: "capitalize" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Mode of Training:</span>{" "}
                                  {ele.mode_of_course ? ele.mode_of_course : "NA"}
                                </ST1>
                              </Box>

                              {/* <ST1 variant="body2">
                                            {ele.designation ? ele.designation : "NA"}
                                          </ST1> */}
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Category:</span>{" "}
                                  {ele.course_category ? ele.course_category : "NA"}
                                </ST1>
                              </Box>

                              {/* <ST1 variant="body2">
                                            {ele.skills ? ele.skills : "NA"}
                                          </ST1> */}
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Fee:</span>{" "}
                                  {ele.fees ? `₹ ${ele.fees}` : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Certificate Available:</span>{" "}
                                  {ele.certificate_avail
                                    ? ele.certificate_avail === 1
                                      ? "YES"
                                      : "NO"
                                    : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Instructor Name:</span>{" "}
                                  {ele.instructor_name ? ele.instructor_name : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Language:</span>{" "}
                                  {ele.language ? ele.language : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Duration of Course:</span>{" "}
                                  {ele.duration ? `${ele.duration}` : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Start Date:</span>{" "}
                                  {ele.start_date ? ele.start_date : "NA"}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                mb: 0.75,
                              }}
                            >
                              <Box>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C", padding: "2px" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Discount:</span>{" "}
                                  {ele.discount_percent !== "" ||
                                  ele.discount_percent !== "0" ||
                                  ele.discount_percent !== "-" ||
                                  ele.discount_percent !== 0
                                    ? // && ele.discounted_fee !== ""
                                      "NA"
                                    : `${ele.discount_percent}% of course fees`}
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item lg={12} sm={12}>
                            <Box sx={{ display: "flex", mb: 0.75 }}>
                              <Box sx={{ minWidth: "220px" }}>
                                <ST1
                                  variant="body2"
                                  sx={{ p: 0.25 }}
                                  // style={{ color: "#6C6C6C" }}
                                >
                                  <span style={{ color: "#6C6C6C" }}>Course Description:</span>{" "}
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#000000" }}
                                    dangerouslySetInnerHTML={createMarkup(
                                      ele.description ? ele.description : "<p>NA</p>"
                                    )}
                                  />
                                </ST1>
                              </Box>
                            </Box>
                          </Grid>
                          {/* </Box> */}
                        </Grid>
                      )}
                    </Box>
                    {viewIndex === "" ? (
                      <Box
                        sx={{
                          width: "100%",
                          // height: "24px",
                          // background: "#C6C6C6",
                          textAlign: "center",
                          paddingTop: "16px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          onClick={() => (
                            setViewIndex(id),
                            setViewDetails(""),
                            setDuration(ele.duration),
                            setCourseMode(ele.mode_of_course),
                            HandleViewBatches(ele.courseId)
                          )}
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#FF7500",
                            "&:hover": {
                              cursor: "pointer",
                            },
                          }}
                        >
                          View Batches <img src={v1} alt="" />
                        </Typography>
                      </Box>
                    ) : viewIndex === id ? (
                      <Box
                        sx={{
                          width: "100%",
                          // height: "24px",
                          // background: "#C6C6C6",
                          textAlign: "center",
                          paddingTop: "16px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          onClick={() => (setViewIndex(""), setViewDetails(""))}
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#FF7500",
                            "&:hover": {
                              cursor: "pointer",
                            },
                          }}
                        >
                          Close <img src={v2} alt="" />
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          // height: "24px",
                          // background: "#C6C6C6",
                          textAlign: "center",
                          paddingTop: "16px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          onClick={() => (
                            setViewIndex(id),
                            setViewDetails(""),
                            setDuration(ele.duration),
                            setCourseMode(ele.mode_of_course),
                            HandleViewBatches(ele.courseId)
                          )}
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#FF7500",
                            "&:hover": {
                              cursor: "pointer",
                            },
                          }}
                        >
                          View Batches <img src={v1} alt="" />
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                </Box>
              ))}
            {/* <Pagination defaultCurrent={2} total={courseData.length} showSizeChanger /> */}
          </>
        )}
      </Box>
      {/* Add Batch Modal */}
      <Modal
        show={addBatchModal}
        onHide={() => {
          setAddBatchModal(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
          setCourseId("");
          batchForm.handleReset();
        }}
        centered
        style={{ margin: "0px" }}
        size="lg"
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Add Batch Details</p>

              <IconButton
                onClick={() => (setAddBatchModal(false), setCourseId(""), batchForm.handleReset())}
              >
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              // className="doc-table"
            >
              <SoftBox display="flex" flexDirection="column" alignItems="flex-start" px={2}>
                <SoftBox
                  component="form"
                  role="form"
                  width="100%"
                  // onSubmit={jobpostform.handleSubmit}
                >
                  <Grid container>
                    <SoftBox mt={2} width="100%" height="auto">
                      <Card sx={{ overflow: "visible" }}>
                        <SoftBox width="100%" height="auto">
                          <SoftBox>
                            <SoftBox mb={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Name
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="Enter batch name"
                                      name="batch_name"
                                      id="batch_name"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.batch_name}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.batch_name && batchForm.errors.batch_name ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_name}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Start Date
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="date"
                                      placeholder="Batch start date"
                                      name="start_date"
                                      id="start_date"
                                      className="form-control"
                                      min={today}
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.start_date}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.start_date && batchForm.errors.start_date ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.start_date}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Course Duration
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Duration"
                                      isDisabled
                                      // id="outlined-small-input"
                                      value={{ label: duration }}
                                    />
                                  </SoftBox>
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      // flexDirection="row"
                                      // justifyContent="space-between"
                                    >
                                      <SoftTypography
                                        fontWeight="medium"
                                        fontSize="16px"
                                        lineHeight="20px"
                                        mb={1}
                                      >
                                        Weekly Off Days
                                      </SoftTypography>
                                      {/* <SoftBox
                                        sx={{
                                          color: "red",
                                          position: "inherit",
                                          paddingLeft: "2px",
                                          fontSize: "15px",
                                        }}
                                      >
                                        <sup>*</sup>
                                      </SoftBox> */}
                                    </SoftBox>
                                    {/* <SoftBox sx={{ display: "flex", width: "100%" }}> */}
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select weekly off days"
                                      isMulti
                                      options={daysOfWeek}
                                      // onChange={(e) => {
                                      //   batchForm.setFieldValue("state", e ? e.label : "");
                                      //   setBatchState(e.label);
                                      // }}
                                      onChange={(e) => {
                                        if (e) {
                                          console.log(e);
                                          batchForm.setFieldValue(
                                            "off_days",
                                            e.map((ele) => ele.value).join(",")
                                          );
                                        }
                                      }}
                                    />
                                    {/* </SoftBox> */}
                                    {/* {batchForm.touched.off_days &&
                                      batchForm.errors.off_days ? (
                                        <span style={{ color: "red", fontSize: "12px" }}>
                                          {batchForm.errors.off_days}{" "}
                                        </span>
                                      ) : null} */}
                                  </SoftBox>
                                </Grid>
                                {duration.includes("hrs") ||
                                  (duration.includes("Hours") && (
                                    <Grid item xs={12} lg={4} md={6}>
                                      <SoftBox width="100%">
                                        <SoftBox
                                          width="100%"
                                          mb={1}
                                          display="flex"
                                          flexDirection="row"
                                          justifyContent="space-between"
                                        >
                                          <SoftBox display="flex" flexDirection="row">
                                            <SoftTypography
                                              fontWeight="medium"
                                              fontSize="16px"
                                              lineHeight="20px"
                                              mb={1}
                                            >
                                              No. of Hours Per Day
                                            </SoftTypography>
                                            <SoftBox
                                              sx={{
                                                color: "red",
                                                position: "inherit",
                                                paddingLeft: "2px",
                                                fontSize: "15px",
                                              }}
                                            >
                                              <sup>*</sup>
                                            </SoftBox>
                                          </SoftBox>
                                        </SoftBox>
                                        <SoftInput
                                          type="number"
                                          placeholder="Enter no. of hours per day"
                                          name="hrs_per_day"
                                          id="hrs_per_day"
                                          inputProps={{
                                            min: 0,
                                            max: parseInt(duration.split(" ")[0]) && 24,
                                          }}
                                          onKeyPress={(e) => {
                                            console.log(e, "11se");
                                            if (e.key === "-" || e.key === "e" || e.key === "E") {
                                              e.preventDefault();
                                            }
                                          }}
                                          // onChange={batchForm.handleChange}
                                          onChange={(e) => {
                                            if (
                                              e.target.value <= parseInt(duration.split(" ")[0]) &&
                                              e.target.value <= 24
                                            ) {
                                              batchForm.handleChange(e);
                                            }
                                          }}
                                          value={batchForm.values.hrs_per_day}
                                        />
                                      </SoftBox>
                                      {/* {batchForm.touched.batch_limit && batchForm.errors.batch_limit ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_limit}{" "}
                                    </span>
                                  ) : null} */}
                                    </Grid>
                                  ))}
                                {/* <Grid item xs={12} lg={6}>
                                    <SoftBox width="100%">
                                      <SoftBox
                                        width="100%"
                                        mb={1}
                                        display="flex"
                                        flexDirection="row"
                                        justifyContent="space-between"
                                      >
                                        <SoftBox display="flex" flexDirection="row">
                                          <SoftTypography
                                            fontWeight="medium"
                                            fontSize="16px"
                                            lineHeight="20px"
                                            mb={1}
                                          >
                                            End Date
                                          </SoftTypography>
                                          <SoftBox
                                            sx={{
                                              color: "red",
                                              position: "inherit",
                                              paddingLeft: "2px",
                                              fontSize: "15px",
                                            }}
                                          >
                                            <sup>*</sup>
                                          </SoftBox>
                                        </SoftBox>
                                      </SoftBox>
                                      <SoftInput
                                        type="date"
                                        placeholder="Batch end date"
                                        name="end_date"
                                        id="end_date"
                                        onChange={batchForm.handleChange}
                                        value={batchForm.values.end_date}
                                      />
                                    </SoftBox>
                                    {batchForm.touched.end_date && batchForm.errors.end_date ? (
                                      <span style={{ color: "red", fontSize: "12px" }}>
                                        {batchForm.errors.end_date}{" "}
                                      </span>
                                    ) : null}
                                  </Grid> */}
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Mode of Batch
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select mode"
                                      isDisabled
                                      options={[
                                        {
                                          label: "Classroom Training",
                                          value: "Classroom Training",
                                        },
                                        { label: "Online", value: "Online" },
                                      ]}
                                      onChange={
                                        (e) => batchForm.setFieldValue("batch_type", courseMode)
                                        // setOrgNameID(e.value)
                                      }
                                      value={{ label: courseMode }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.batch_type && batchForm.errors.batch_type ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_type}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Batch Limit
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="number"
                                      placeholder="Enter batch limit"
                                      name="batch_limit"
                                      id="batch_limit"
                                      inputProps={{ min: 0 }}
                                      onKeyPress={(e) => {
                                        if (e.key === "-" || e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.batch_limit}
                                    />
                                  </SoftBox>
                                  {/* {batchForm.touched.batch_limit && batchForm.errors.batch_limit ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_limit}{" "}
                                    </span>
                                  ) : null} */}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Select State
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select state"
                                      options={stateList}
                                      onChange={(e) => {
                                        batchForm.setFieldValue("state", e ? e.label : "");
                                        setBatchState(e.label);
                                      }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.state && batchForm.errors.state ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.state}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Select District
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select district"
                                      options={districtList}
                                      onChange={
                                        (e) => batchForm.setFieldValue("district", e ? e.label : "")
                                        // setOrgNameID(e.value)
                                      }
                                      // value={{ label: batchForm.values.batch_type }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.district && batchForm.errors.district ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.district}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Address
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="Address"
                                      name="address"
                                      id="address"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.address}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.address && batchForm.errors.address ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.address}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                {/* <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                           Name
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="Batch Name"
                                      name="batch_name"
                                      id="batch_name"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.batch_name}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.batch_name && batchForm.errors.batch_name ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_name}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Start Date
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="date"
                                      placeholder="Batch Start Date"
                                      name="start_date"
                                      id="start_date"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.start_date}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.start_date && batchForm.errors.start_date ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.start_date}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                           End Date
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="date"
                                      placeholder="Batch End Date"
                                      name="end_date"
                                      id="end_date"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.end_date}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.end_date && batchForm.errors.end_date ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.end_date}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Mode of Batch
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select Mode"
                                      options={[
                                        { label: "Online", value: "Online" },
                                        {
                                          label: "Classroom Training",
                                          value: "Classroom Training",
                                        },
                                      ]}
                                      onChange={
                                        (e) =>
                                          batchForm.setFieldValue("batch_type", e ? e.label : "")
                                        // setOrgNameID(e.value)
                                      }
                                      // value={{ label: batchForm.values.batch_type }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.batch_type && batchForm.errors.batch_type ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_type}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                         Limit
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="number"
                                      placeholder="Batch Limit"
                                      name="batch_limit"
                                      id="batch_limit"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.batch_limit}
                                    />
                                  </SoftBox>
                                  {/* {batchForm.touched.batch_limit && batchForm.errors.batch_limit ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.batch_limit}{" "}
                                    </span>
                                  ) : null} *
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Select State
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select State"
                                      options={stateList}
                                      onChange={(e) => {
                                        batchForm.setFieldValue("state", e ? e.label : "");
                                        setBatchState(e.label);
                                      }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.state && batchForm.errors.state ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.state}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Select District
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <Select
                                      styles={stylesDD}
                                      placeholder="Select District"
                                      options={districtList}
                                      onChange={
                                        (e) => batchForm.setFieldValue("district", e ? e.label : "")
                                        // setOrgNameID(e.value)
                                      }
                                      // value={{ label: batchForm.values.batch_type }}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.district && batchForm.errors.district ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.district}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          Address
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="Address"
                                      name="address"
                                      id="address"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.address}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.address && batchForm.errors.address ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.address}{" "}
                                    </span>
                                  ) : null}
                                </Grid> */}
                              </Grid>
                              <hr />
                              <p className="HeaderCSV" style={{ marginLeft: "-10px" }}>
                                POC Details
                              </p>
                              <Grid container spacing={2}>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <Tooltip key="1" title="Person of Contact" position="top">
                                          <SoftTypography
                                            fontWeight="medium"
                                            fontSize="16px"
                                            lineHeight="20px"
                                            mb={1}
                                          >
                                            Name
                                          </SoftTypography>
                                        </Tooltip>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="POC Name"
                                      name="spoc_name"
                                      id="spoc_name"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.spoc_name}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.spoc_name && batchForm.errors.spoc_name ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.spoc_name}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <Tooltip key="1" title="Email" position="top">
                                          <SoftTypography
                                            fontWeight="medium"
                                            fontSize="16px"
                                            lineHeight="20px"
                                            mb={1}
                                          >
                                            Email
                                          </SoftTypography>
                                        </Tooltip>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="text"
                                      placeholder="POC Email"
                                      name="spoc_email"
                                      id="spoc_email"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.spoc_email}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.spoc_email && batchForm.errors.spoc_email ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.spoc_email}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <Tooltip key="1" title="Mobile" position="top">
                                          <SoftTypography
                                            fontWeight="medium"
                                            fontSize="16px"
                                            lineHeight="20px"
                                            mb={1}
                                          >
                                            Mobile
                                          </SoftTypography>
                                        </Tooltip>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="tel"
                                      placeholder="Enter mobile number"
                                      inputProps={{
                                        maxLength: "10",
                                      }}
                                      id="spoc_phone"
                                      name="spoc_phone"
                                      onChange={batchForm.handleChange}
                                      value={batchForm.values.spoc_phone}
                                    />
                                  </SoftBox>
                                  {batchForm.touched.spoc_phone && batchForm.errors.spoc_phone ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchForm.errors.spoc_phone}{" "}
                                    </span>
                                  ) : null}
                                </Grid>
                              </Grid>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      </Card>
                    </SoftBox>
                  </Grid>
                </SoftBox>
              </SoftBox>
              <SoftBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ ml: "auto", mr: "auto" }}
              >
                <Box sx={{ p: 1 }}>
                  <SoftBox
                    sx={{
                      height: "45px",
                      backgroundColor: "#3B5092",
                      borderRadius: "5px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={batchForm.handleSubmit}
                  >
                    <SoftTypography
                      display="flex"
                      justifyContent="center"
                      sx={{
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Submit
                    </SoftTypography>
                  </SoftBox>
                </Box>

                <Box sx={{ p: 1 }}>
                  <SoftBox
                    sx={{
                      height: "45px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #3B5092",
                      borderRadius: "5px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setAddBatchModal(false);
                      setCourseId("");
                      batchForm.handleReset();
                    }}
                  >
                    <SoftTypography
                      display="flex"
                      justifyContent="center"
                      sx={{
                        color: "#3B5092",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Cancel
                    </SoftTypography>
                  </SoftBox>
                </Box>
              </SoftBox>
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Add Batch Modal */}
      {/* Upload cand Modal */}
      <Modal
        show={uploadCandModal}
        onHide={() => {
          setUploadCandModal(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Upload Candidate</p>

              <IconButton
                onClick={() => (setUploadCandModal(false), setCSVFile(""), setRefFile(""))}
              >
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox m={2}>
              <SoftBox
                my={1}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#F7F5FE",
                  border: "1px dashed #384EB74D",
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickFile()}
              >
                <img src={upload} alt="" />
                <SoftBox sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <SoftTypography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                    Drag & drop files or
                  </SoftTypography>
                  <SoftTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#3B5092",
                      textDecoration: "underline",
                    }}
                  >
                    Browse
                  </SoftTypography>
                </SoftBox>
                <SoftTypography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: refFile == "" ? "#676767" : "#3B5092",
                  }}
                >
                  {refFile == "" ? "Supported formats: xlsx (Excel)" : refFile.name}
                </SoftTypography>
                <input
                  // className="form-control"
                  type="file"
                  accept=".xlsx"
                  id="datasource"
                  name="datasource"
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    // const file = e.target.files[0],
                    console.log("refFile ", e.target.files[0]), setCSVFile(e.target.files[0]);
                    setRefFile(e.target.files[0]);
                  }}
                />
              </SoftBox>
              <SoftBox display="flex" justifyContent="center">
                <Link to="/Data-Upload-Template.xlsx" target="_blank" download>
                  <SoftBox
                    sx={{
                      border: "1px solid #8080803b",
                      borderRadius: 1,
                      p: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <CloudDownloadIcon /> */}
                    <svg
                      width="21"
                      height="17"
                      viewBox="0 0 21 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 6V12M10.5 12L8.5 10M10.5 12L12.5 10M6.9 15.5C3.91766 15.5 1.5 13.1044 1.5 10.1493C1.5 7.70008 3.3 5.4375 6 5C6.84694 2.98637 8.85139 1.5 11.1893 1.5C14.184 1.5 16.6317 3.82251 16.8 6.75C18.3893 7.44488 19.5 9.15031 19.5 10.9969C19.5 13.4839 17.4853 15.5 15 15.5L6.9 15.5Z"
                        stroke="#3B5092"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <SoftTypography sx={{ color: "#072AC8", fontSize: "14px", pl: 1 }}>
                      Download Template
                    </SoftTypography>
                  </SoftBox>
                </Link>
              </SoftBox>

              {/* {refFile1 !== "" && ( */}
              <SoftBox display="flex" justifyContent="center" mt={1}>
                <Select
                  isClearable
                  // value={jobList?.filter((ele) => courseId === ele.value)}
                  placeholder="Select Stage"
                  options={stageoptions}
                  onChange={(e) => setStageSelect(e)}
                  styles={stylesDD1}
                />
              </SoftBox>
              {/* )}  */}

              <SoftBox width="100%" pl={2} mt={3} display="flex" justifyContent="center" gap={2}>
                <SoftBox
                  // pl={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={0.2}
                  borderColor="#8080804f"
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFFF",
                    // borderColor: "red",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => (setCSVFile(""), setRefFile(""), setUploadCandModal(false))}
                >
                  <SoftTypography
                    sx={{
                      color: "#3B5092",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Cancel
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  type="submit"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    height: "40px",
                    backgroundColor: "#3B5092",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() =>
                    // ds === "" || CSVFile === ""
                    //   ? () =>
                    //       Swal.fire({
                    //         icon: "info",
                    //         title: "Please select datasource",
                    //         //text: err?.data["User Message"],
                    //         showConfirmButton: false,
                    //         timer: 3000,
                    //       })
                    //   :
                    HandleBulkUpload()
                  }
                >
                  <SoftTypography
                    alignItems="center"
                    sx={{
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Upload
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Upload cand Modal */}
      {/* Upload Attendence Modal */}
      <Modal
        show={uploadAttdModal}
        onHide={() => {
          setUploadAttdModal(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Upload Attendance</p>

              <IconButton onClick={() => setUploadAttdModal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox m={2}>
              <SoftBox
                my={1}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#F7F5FE",
                  border: "1px dashed #384EB74D",
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickFile()}
              >
                <img src={upload} alt="" />
                <SoftBox sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <SoftTypography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                    Drag & drop files or
                  </SoftTypography>
                  <SoftTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#3B5092",
                      textDecoration: "underline",
                    }}
                  >
                    Browse
                  </SoftTypography>
                </SoftBox>
                <SoftTypography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: refFile1 == "" ? "#676767" : "#3B5092",
                  }}
                >
                  {refFile1 == "" ? "Supported formats: xlsx (Excel)" : refFile1.name}
                </SoftTypography>
                <input
                  // className="form-control"
                  type="file"
                  accept=".xlsx"
                  id="attendence"
                  name="attendence"
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    // const file = e.target.files[0],
                    console.log("refFile1 ", e.target.files[0]), setCSVFile1(e.target.files[0]);
                    setRefFile1(e.target.files[0]);
                  }}
                />
              </SoftBox>
              <SoftBox display="flex" justifyContent="center">
                <Link to="/Attendence-Upload-Sheet.xlsx" target="_blank" download>
                  <SoftBox
                    sx={{
                      border: "1px solid #8080803b",
                      borderRadius: 1,
                      p: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <CloudDownloadIcon /> */}
                    <svg
                      width="21"
                      height="17"
                      viewBox="0 0 21 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 6V12M10.5 12L8.5 10M10.5 12L12.5 10M6.9 15.5C3.91766 15.5 1.5 13.1044 1.5 10.1493C1.5 7.70008 3.3 5.4375 6 5C6.84694 2.98637 8.85139 1.5 11.1893 1.5C14.184 1.5 16.6317 3.82251 16.8 6.75C18.3893 7.44488 19.5 9.15031 19.5 10.9969C19.5 13.4839 17.4853 15.5 15 15.5L6.9 15.5Z"
                        stroke="#3B5092"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <SoftTypography sx={{ color: "#072AC8", fontSize: "14px", pl: 1 }}>
                      Download Template
                    </SoftTypography>
                  </SoftBox>
                </Link>
              </SoftBox>
              <SoftBox></SoftBox>
              <SoftBox width="100%" pl={2} mt={3} display="flex" justifyContent="center" gap={2}>
                <SoftBox
                  // pl={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={0.2}
                  borderColor="#8080804f"
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFFF",
                    // borderColor: "red",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => (setCSVFile1(""), setRefFile1(""), setUploadAttdModal(false))}
                >
                  <SoftTypography
                    sx={{
                      color: "#3B5092",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Cancel
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  type="submit"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    height: "40px",
                    backgroundColor: "#3B5092",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => HandleAttendenceUpload()}
                >
                  <SoftTypography
                    alignItems="center"
                    sx={{
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Upload
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Upload Attendence Modal */}
      {/* Upload Media Modal */}
      <Modal
        show={uploadMediaModal}
        onHide={() => {
          setUploadMediaModal(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Upload Media</p>

              <IconButton onClick={() => setUploadMediaModal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox m={2}>
              <SoftBox
                my={1}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#F7F5FE",
                  border: "1px dashed #384EB74D",
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickFile()}
              >
                <img src={upload} alt="" />
                <SoftBox sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <SoftTypography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                    Drag & drop files or
                  </SoftTypography>
                  <SoftTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#3B5092",
                      textDecoration: "underline",
                    }}
                  >
                    Browse
                  </SoftTypography>
                </SoftBox>
                <SoftTypography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: refFile2 == "" ? "#676767" : "#3B5092",
                    height: "100px",
                  }}
                >
                  {refFile2.length === 0 ? (
                    "Supported formats: .png, .jpeg, .jpg, .mp4"
                  ) : (
                    <ol>
                      {refFile2.map((itm, id) => (
                        <li key={id}>
                          {itm.name} - {itm.type}
                        </li>
                      ))}
                    </ol>
                  )}
                </SoftTypography>
                <input
                  // className="form-control"
                  type="file"
                  accept="image/*,video/*"
                  id="media"
                  name="media"
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    // const file = e.target.files[0],
                    const files = Array.from(e.target.files);
                    setRefFile2((prevFiles) => [...prevFiles, ...files]);
                    // setCSVFile2(e.target.files);
                    // console.log("refFile2 ", e.target.files), setCSVFile2(e.target.files);
                    // setRefFile2(...refFile2, e.target.files);
                  }}
                  multiple
                />
              </SoftBox>
              <p
                // className="HeaderCSV"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  marginTop: "12px",
                }}
              >
                or
              </p>
              <SoftBox>
                <SoftInput
                  type="text"
                  placeholder="Drive link"
                  name="drive_link"
                  id="drive_link"
                  onChange={(e) => setCSVFile2(e.target.value)}
                  // value={batchForm.values.batch_name}
                />
              </SoftBox>
              <SoftBox my={1}>
                <SoftInput
                  type="date"
                  placeholder=""
                  name="mdUpDate"
                  id="mdUpDate"
                  onChange={(e) => {
                    setMdUpDate(e.target.value);
                    console.log(e, "era");
                  }}
                  value={mdUpDate}
                />
              </SoftBox>
              <SoftBox width="100%" pl={2} mt={3} display="flex" justifyContent="center" gap={2}>
                <SoftBox
                  // pl={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={0.2}
                  borderColor="#8080804f"
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFFF",
                    // borderColor: "red",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => (
                    setCSVFile2(""), setRefFile2(""), setUploadMediaModal(false), setMdUpDate("")
                  )}
                >
                  <SoftTypography
                    sx={{
                      color: "#3B5092",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Cancel
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  type="submit"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    height: "40px",
                    backgroundColor: "#3B5092",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => HandleUploadMediaLoop()}
                >
                  <SoftTypography
                    alignItems="center"
                    sx={{
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Upload
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Upload Feedback Modal */}

      <Modal
        show={viewMediaModal}
        onHide={() => {
          setViewMediamodal(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>

              <IconButton onClick={() => setViewMediamodal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="doc-table"
            >
              <table>
                <tr>
                  <th className="doc-head">Upload date</th>
                  <th className="doc-head">View</th>
                </tr>

                {batchDetail?.media?.map((ele, id) => (
                  <tr key={id}>
                    <td>{moment(ele.createddt).format("DD-MM-YYYY")}</td>
                    <td>
                      <a href={ele.media} rel="noreferrer" target="_blank">
                        {"Click"}
                      </a>
                    </td>
                  </tr>
                ))}
              </table>
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Edit Batch Modal */}
      <EditBatch
        batchModalE={batchModalE}
        setBatchModalE={setBatchModalE}
        batchDetail={batchDetail}
        obj={{ today: today, duration: duration, courseMode: courseMode }}
        // handleOrgFunc={fetchOrgList}
        // handleRoleFunc={fetchOgrRole}
        // fetchadminList={fetchOgrRole}
      />
      {/* Edit Batch Modal */}

      <Index
        open={showFilter}
        setOpen={setShowFilter}
        statefilter={statefilter}
        setStatefilter={setStatefilter}
        districtfilter={districtfilter}
        setDistrictfilter={setDistrictfilter}
        datefilter={datefilter}
        setDatefilter={setDatefilter}
        resetfunc={resetfunc}
        jffilter={jffilter}
        setJffilter={setJffilter}
        // table={table}
        educationfilter={educationfilter}
        setEducationfilter={setEducationfilter}
        rolefilter={rolefilter}
        setRolefilter={setRolefilter}
        degreefilter={degreefilter}
        setDegreefilter={setDegreefilter}
        boardingfilter={boardingfilter}
        setBoardingfilter={setBoardingfilter}
        setFunc={setFunc}
        // fetchFilteredCandidates={fetchFilteredCandidates}
      />

      {/* modal for export */}
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p className="HeaderCSV">Select columns to export</p>

              <button className="CloseBtn" onClick={() => setShow(false)}>
                <span>
                  <CloseIcon fontSize="small" />
                </span>
              </button>
            </Box>

            {colHeaders.map((ele, index) => (
              <>
                <ul className="UlCSV" key={index}>
                  <input
                    type="checkbox"
                    checked={ele.isExportable}
                    onChange={(event) =>
                      handleFormChange12(event, index, colHeaders, setColHeaders)
                    }
                  />
                  <span className="ListCSV">&nbsp;{ele.label}</span>
                </ul>
              </>
            ))}

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <button className="login-btn4" onClick={() => setShow(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>

              <button className="login-btn3">
                {/* <SoftTypography display="flex" justifyContent="center" sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}>
                      Download
                    </SoftTypography> */}
                <CSVLink
                  // data={tablerow.length === 0 ? searchData : tablerow}
                  data={courseData}
                  filename={fileName}
                  headers={colHeaders.filter((ele) => ele.isExportable === true)}
                >
                  <span className="login-btn3-Text">Export</span>
                </CSVLink>
              </button>
            </Box>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for export */}
    </DashboardLayout>
  );
};

export default CoursesAssigned;
